import { ActionCreator, AnyAction, Reducer } from 'redux';
import {
  Selector,
  Selector1,
  Selector2,
  Selector3,
  ThunkActionCreator,
  AsyncThunkActionCreator,
} from 'shared/state';
import uuidv4 from 'uuid/v4';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  saveSite as doSaveSite,
  createSite as doCreateSite,
  publishSite as doPublishSite,
  publishSiteToDemo as doPublishSiteToDemo,
  unPublishSite as doUnPublishSite,
  archiveSite as doArchiveSite,
  fetchSites as doFetchSites,
  fetchPages as doFetchPages,
  fetchPage as doFetchPage,
  createPage as doCreatePage,
  savePage as doSavePage,
  saveAllPage as doSaveAllPage,
  removePage as doRemovePage,
  fetchSite as doFetchSite,
  fetchSitesByUuid as doFetchSitesByUuid,
  fetchSearchResults as doFetchSearchResults,
  getPagesByTime as doFetchPagesByTime,
} from 'shared/api/sites';
import {
  saveSiteProvisioningStores as doSaveSiteProvisioningStores,
  removeSiteProvisioningStores as doRemoveSiteProvisioningStores,
} from 'shared/api/siteProvisioningStores';
import {
  closeCreatePageDialog,
  closeCreateSiteDialog,
  closePublishNoteDialog,
  closeVersionHistoryDialog,
  openSiteListDialog,
} from './ui';
import { SiteListDialogType } from 'builder/components/SiteListDialog/SiteListDialog';
import templates from 'builder/scenes/SiteBuilder/CreateSiteDialog/templates';
import { FieldType } from 'shared/widgets/Form/types';
import { saveInitialPages, saveInitialSite, saveSitePages } from './site';
import {
  FOOTER_SECTION_ID,
  HEADER_SECTION_ID,
  widgetTypes,
} from 'builder/util/constants';
import {
  TEMPLATES_SITE_ID,
  templateStarter,
} from '../../../builder/scenes/PageTemplates/constants';
import _ from 'lodash';
import { filterValidPages, isContentLoaded } from 'shared/util/pageUtils';
import {
  getBestSectionReferenceContent,
  normalizePageSectionContent,
} from 'shared/state/misc/footerNormalization';

/**
 * Widget actions
 */
export const ADD_CHILD = 'duplo/widgets/ADD_CHILD';
const ADD_SIBLING = 'duplo/widgets/ADD_SIBLING';
const ADOPT_CHILD = 'duplo/widgets/ADOPT_CHILD';
export const UPDATE_WIDGET_POSITION = 'duplo/widgets/UPDATE_WIDGET_POSITION';
export const UPDATE_WIDGET_CONFIG = 'duplo/widgets/UPDATE_WIDGET_CONFIG';
const UPDATE_CURRENT_PAGE_WIDGET_CONFIG =
  'duplo/widgets/UPDATE_CURRENT_PAGE_WIDGET_CONFIG';
const UPDATE_DEFAULT_WIDGET_CONFIG =
  'duplo/widgets/UPDATE_DEFAULT_WIDGET_CONFIG';
const BATCH_UPDATE_REPEATER_WIDGETS =
  'duplo/widgets/BATCH_UPDATE_REPEATER_WIDGETS';
const REMOVE_WIDGET = 'duplo/widgets/DELETE_WIDGET';
const REMOVE_WIDGET_DEFAULT = 'duplo/widgets/DELETE_WIDGET_DEFAULT';

/**
 * Page actions
 */
export const FETCH_PAGES_PENDING = 'duplo/pages/FETCH_PAGES_PENDING';
export const FETCH_PAGES_FULFILLED = 'duplo/pages/FETCH_PAGES_FULFILLED';
export const FETCH_PAGES_FAILED = 'duplo/pages/FETCH_PAGES_FAILED';
export const FETCH_PAGE_FULFILLED = 'duplo/pages/FETCH_PAGE_FULFILLED';
export const FETCH_PAGE_FAILED = 'duplo/pages/FETCH_PAGE_FAILED';

export const CREATE_PAGE_PENDING = 'duplo/pages/CREATE_PAGE_PENDING';
export const CREATE_PAGE_FULFILLED = 'duplo/pages/CREATE_PAGE_FULFILLED';
export const CREATE_PAGE_FAILED = 'duplo/pages/CREATE_PAGE_FAILED';

export const SAVE_PAGE_PENDING = 'duplo/pages/SAVE_PAGE_PENDING';
export const SAVE_PAGE_FULFILLED = 'duplo/pages/SAVE_PAGE_FULFILLED';
export const SAVE_PAGE_FAILED = 'duplo/pages/SAVE_PAGE_FAILED';

export const SAVE_ALL_PAGE_PENDING = 'duplo/pages/SAVE_ALL_PAGE_PENDING';
export const SAVE_ALL_PAGE_FULFILLED = 'duplo/pages/SAVE_ALL_PAGE_FULFILLED';
export const SAVE_ALL_PAGE_FAILED = 'duplo/pages/SAVE_ALL_PAGE_FAILED';

export const REMOVE_PAGE_PENDING = 'duplo/pages/REMOVE_PAGE_PENDING';
export const REMOVE_PAGE_FULFILLED = 'duplo/pages/REMOVE_PAGE_FULFILLED';
export const REMOVE_PAGE_FAILED = 'duplo/pages/REMOVE_PAGE_FAILED';

export const SET_HOME_PAGE = 'duplo/pages/SET_HOME_PAGE';
export const NORMALIZE_HEADER_FOOTER = 'duplo/sites/NORMALIZE_HEADER_FOOTER';

export const UPDATE_CURRENT_PAGE = 'duplo/sites/UPDATE_CURRENT_PAGE';
export const UPDATE_PAGE_DEFAULT_WIDGET =
  'duplo/sites/UPDATE_PAGE_DEFAULT_WIDGET';

/**
 * Site actions
 */
export const FETCH_SITES_PENDING = 'duplo/sites/FETCH_SITES_PENDING';
export const FETCH_SITES_FULFILLED = 'duplo/sites/FETCH_SITES_FULFILLED';
export const FETCH_SITES_FAILED = 'duplo/sites/FETCH_SITES_FAILED';
export const CHANGE_WIDGET_VISIBLE = 'CHANGE_WIDGET_VISIBLE';
export const FETCH_SITES_BY_UUID_PENDING =
  'duplo/sites/FETCH_SITES_BY_UUID_PENDING';
export const FETCH_SITES_BY_UUID_FULFILLED =
  'duplo/sites/FETCH_SITES_BY_UUID_FULFILLED';
export const FETCH_SITES_BY_UUID_FAILED =
  'duplo/sites/FETCH_SITES_BY_UUID_FAILED';
export const FETCH_SITE_PENDING = 'duplo/sites/FETCH_SITE_PENDING';
export const FETCH_SITE_FULFILLED = 'duplo/sites/FETCH_SITE_FULFILLED';
export const FETCH_SITE_FAILED = 'duplo/sites/FETCH_SITE_FAILED';

export const CREATE_SITE_PENDING = 'duplo/sites/CREATE_SITE_PENDING';
export const CREATE_SITE_FULFILLED = 'duplo/sites/CREATE_SITE_FULFILLED';
export const CREATE_SITE_FAILED = 'duplo/sites/CREATE_SITE_FAILED';

export const SAVE_SITE_PENDING = 'duplo/sites/SAVE_SITE_PENDING';
export const SAVE_SITE_FULFILLED = 'duplo/sites/SAVE_SITE_FULFILLED';
export const SAVE_SITE_FAILED = 'duplo/sites/SAVE_SITE_FAILED';

export const PUBLISH_SITE_PENDING = 'duplo/sites/PUBLISH_SITE_PENDING';
export const PUBLISH_SITE_FULFILLED = 'duplo/sites/PUBLISH_SITE_FULFILLED';
export const PUBLISH_SITE_FAILED = 'duplo/sites/PUBLISH_SITE_FAILED';

export const UNPUBLISH_SITE_PENDING = 'duplo/sites/UNPUBLISH_SITE_PENDING';
export const UNPUBLISH_SITE_FULFILLED = 'duplo/sites/UNPUBLISH_SITE_FULFILLED';
export const UNPUBLISH_SITE_FAILED = 'duplo/sites/UNPUBLISH_SITE_FAILED';

export const ARCHIVE_SITE_PENDING = 'duplo/sites/ARCHIVE_SITE_PENDING';
export const ARCHIVE_SITE_FULFILLED = 'duplo/sites/ARCHIVE_SITE_FULFILLED';
export const ARCHIVE_SITE_FAILED = 'duplo/sites/ARCHIVE_SITE_FAILED';
export const UPDATE_SITE = 'duplo/sites/UPDATE_SITE';
export const SET_ACTIVE_WIDGET_ID = 'duplo/sites/SET_ACTIVE_WIDGET_ID';
export const UPDATE_PAGE_CONTENT = 'duplo/pages/UPDATE_PAGE_CONTENT';
export const FETCH_PAGES_BY_TIME_PENDING =
  'duplo/pages/FETCH_PAGES_BY_TIME_PENDING';
export const FETCH_PAGES_BY_TIME_FULFILLED =
  'duplo/pages/FETCH_PAGES_BY_TIME_FULFILLED';
export const FETCH_PAGES_BY_TIME_FAILED =
  'duplo/pages/FETCH_PAGES_BY_TIME_FAILED';

export const SET_SITE_DATA_FOR_TEMPLATE_EDITING =
  'duplo/sites/SET_SITE_DATA_FOR_TEMPLATE_EDITING';
export const RESET_SITE_DATA_FOR_TEMPLATE_EDITING =
  'duplo/sites/RESET_SITE_DATA_FOR_TEMPLATE_EDITING';
export const SET_PENDING_DEFAULT_WIDGET_FETCHES =
  'duplo/sites/SET_PENDING_DEFAULT_WIDGET_FETCHES';

type NewFont = {
  size: {
    body: {
      base: {
        value: number;
      };
    };
  };
  weight: {
    base: {
      value: string;
    };
  };
  family: {
    base: {
      value: string;
    };
  };
};

export interface SiteSlice extends Site {
  pages: {
    [index: number]: Page;
  };
  prevSiteProvisioningStores?: Array<number>;
  meta: StateMeta;
}

export interface State {
  data: Array<SiteSlice>;
  meta: StateMeta;
  publishMeta: StateMeta;
  saveSiteMeta: StateMeta & { siteId?: number };
  activeWidgetId: string;
  createSiteMeta: StateMeta;
  newSiteId: number;
  // True when a header/footer (defaultWidget) edit has been made and there
  // are still pages with placeholder content that haven't been fetched yet.
  hasPendingDefaultWidgetFetches: boolean;
}

const defaultState: State = {
  meta: {
    pending: false,
    successful: false,
  },
  publishMeta: {
    pending: false,
  },
  saveSiteMeta: {
    pending: false,
  },
  data: [],
  activeWidgetId: 'root',
  createSiteMeta: {
    pending: false,
    successful: false,
  },
  newSiteId: undefined,
  hasPendingDefaultWidgetFetches: false,
};

const withSite = (
  state: State,
  siteId: number,
  cb: (slice: SiteSlice) => SiteSlice
) => {
  return {
    ...state,
    data: state.data.map(site => {
      if (siteId === site.siteId) {
        return cb(site);
      }
      return site;
    }),
  };
};

const withPage = (
  state: State,
  siteId: number,
  pageId: number,
  cb: (slice: Page) => Page
) => {
  return withSite(state, siteId, site => {
    return {
      ...site,
      pages: {
        ...site.pages,
        [pageId]: cb(site.pages[pageId]),
      },
    };
  });
};

const withCurrentPageVersion = (
  state: State,
  siteId: number,
  pageId: number,
  cb: (slice: PageVersion) => PageVersion
) => {
  return withPage(state, siteId, pageId, page => ({
    ...page,
    current: cb(page.current),
  }));
};

const updateDefaultWidget = (
  state: State,
  siteId: number,
  pageId: number,
  widgetId: string,
  cb: (slice: Widget<any>) => Widget<any>
) => {
  return withCurrentPageVersion(state, siteId, pageId, page => {
    // Skip placeholder pages — spreading templates[0].widgets would create a
    // new object reference that breaks the sentinel check in FETCH_PAGE_FULFILLED,
    // causing the guard to treat template content as real user content and
    // discard the server response. Propagation in FETCH_PAGE_FULFILLED applies
    // the change when the page is eventually fetched.
    if (!isContentLoaded(page)) return page;
    return {
      ...page,
      content: {
        ...page.content,
        [widgetId]: cb(page.content[widgetId]),
      },
    };
  });
};

const applyInlineBannerMarginsToPage = (
  page: Page | undefined
): Page | undefined => {
  if (!page?.current?.content) return page;

  const content = page.current.content;
  const inlineBanner = Object.values(content).find(
    (widget: any) =>
      widget?.type === widgetTypes.Banner &&
      widget?.config?.visible !== false &&
      widget?.config?.placement !== 'Sticky Bottom (Fixed to Screen)'
  ) as Widget<any> | undefined;

  const bannerHeight = inlineBanner?.config?.height ?? 0;
  const headerChildren = content[HEADER_SECTION_ID]?.children ?? [];
  const bannerChildren = inlineBanner?.children ?? [];
  const bannerId = inlineBanner?.id;

  const updatedContent = { ...content } as any;
  Object.keys(updatedContent)
    .filter(
      id =>
        id !== 'root' &&
        id !== HEADER_SECTION_ID &&
        id !== bannerId &&
        !headerChildren.includes(id) &&
        !bannerChildren.includes(id)
    )
    .forEach(id => {
      const widget = updatedContent[id];
      const config = { ...(widget?.config ?? {}) };
      config.marginTop = bannerHeight;
      config.appliedBannerHeight = bannerHeight;
      updatedContent[id] = {
        ...widget,
        config,
      };
    });

  return {
    ...page,
    current: {
      ...page.current,
      content: updatedContent,
    },
  };
};

export const withWidget = (
  state: State,
  siteId: number,
  pageId: number,
  widgetId: string,
  cb: (slice: Widget<any>) => Widget<any>
) => {
  return withCurrentPageVersion(state, siteId, pageId, page => {
    return {
      ...page,
      forms: {
        ...page?.forms,
        update: [
          ...(page?.forms?.update || []),
          ...((page.content[widgetId]?.type === widgetTypes.Form &&
            !page?.forms?.create?.includes(widgetId) &&
            !page?.forms?.update?.includes(widgetId) && [widgetId]) ||
            []),
        ],
      },
      content: {
        ...page.content,
        [widgetId]: cb(page.content[widgetId]),
      },
    };
  });
};

/**
 * Remove any links to a page within a nav structure
 * @param pageId ID of page being deleted
 * @param items Navigation items
 */
const removePageFromNav = (
  pageId: number,
  items: Array<NavItem>
): Array<NavItem> => {
  return items
    .filter(item => {
      if (item.type === 'page') {
        return item.pageId !== pageId;
      }
      return true;
    })
    .map(item => {
      if (item.type === 'section') {
        return {
          ...item,
          children: removePageFromNav(pageId, item.children),
        };
      }
      return item;
    });
};

// removes children from non-section nav-items
const removeInvalidChildren = (navItems: NavItem[]) => {
  navItems.forEach(item => {
    if (item.type !== 'section' && item.children) {
      item.children = null;
    }
    if (item.children) {
      removeInvalidChildren(item.children);
    }
  });
};

type SlimPageReference = {
  id: number;
  title: string;
  slug: string;
};

const PAGE_REFERENCE_KEYS = new Set(['selectedPage', 'pageSelected']);

const isPlainObject = (value: unknown): value is Record<string, any> => {
  return value != null && typeof value === 'object' && !Array.isArray(value);
};

const toNumberIfPossible = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const parsed = Number(value);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

  return undefined;
};

const buildPageLookup = (pages: Page[]): Map<number, SlimPageReference> => {
  return pages.reduce((lookup, page) => {
    const id = toNumberIfPossible(page?.id);
    const title = page?.current?.title;
    const slug = page?.current?.slug;

    if (id != null && typeof title === 'string' && typeof slug === 'string') {
      lookup.set(id, { id, title, slug });
    }

    return lookup;
  }, new Map<number, SlimPageReference>());
};

const extractSlimPageReference = (
  value: unknown,
  pageLookup: Map<number, SlimPageReference>
): SlimPageReference | null => {
  if (!isPlainObject(value)) {
    return null;
  }

  const id = toNumberIfPossible(value.id);
  if (id == null) {
    return null;
  }

  const current = isPlainObject(value.current) ? value.current : undefined;
  const fromLookup = pageLookup.get(id);
  const title =
    (typeof value.title === 'string' && value.title) ||
    (typeof current?.title === 'string' && current.title) ||
    fromLookup?.title;
  const slug =
    (typeof value.slug === 'string' && value.slug) ||
    (typeof current?.slug === 'string' && current.slug) ||
    fromLookup?.slug;

  if (!title || !slug) {
    return null;
  }

  // Guard against converting arbitrary id-bearing objects in config.
  const pageLikeSignals =
    isPlainObject(value.current) ||
    typeof value.title === 'string' ||
    typeof value.slug === 'string' ||
    Array.isArray(value.versions) ||
    value.pageId != null ||
    pageLookup.has(id);

  if (!pageLikeSignals) {
    return null;
  }

  return { id, title, slug };
};

const normalizePageReferencesInContent = (
  content: PageContent,
  pageLookup: Map<number, SlimPageReference>
): PageContent => {
  if (!isPlainObject(content)) {
    return content;
  }

  const visit = (node: unknown) => {
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }

    if (!isPlainObject(node)) {
      return;
    }

    Object.keys(node).forEach(key => {
      if (PAGE_REFERENCE_KEYS.has(key)) {
        const slimRef = extractSlimPageReference(node[key], pageLookup);
        if (slimRef) {
          const isAlreadySlim =
            isPlainObject(node[key]) &&
            node[key].id === slimRef.id &&
            node[key].title === slimRef.title &&
            node[key].slug === slimRef.slug &&
            Object.keys(node[key]).length === 3;

          if (!isAlreadySlim) {
            node[key] = slimRef;
          }
        }
      }

      visit(node[key]);
    });
  };

  visit(content);
  return content;
};

const hydrateFetchedPages = (pages: Page[]): { [index: string]: Page } => {
  const pageLookup = buildPageLookup(pages);
  const hydratedPages = pages.reduce(
    (acc: { [index: string]: Page }, page: Page) => {
      const hydratedPage = _.cloneDeep(page);
      const { content } = hydratedPage.current;

      if (content === undefined || content === null) {
        //TODO: ensure template index is correct
        hydratedPage.current.content = templates[0].widgets;
        hydratedPage.current.loadState = 'unloaded';
      } else {
        hydratedPage.current.loadState = 'loaded';
      }

      hydratedPage.current.content = normalizePageReferencesInContent(
        hydratedPage.current.content,
        pageLookup
      );
      if (isContentLoaded(hydratedPage.current)) {
        normalizeDefaultSectionContent(
          hydratedPage.current.content,
          HEADER_SECTION_ID
        );
        normalizeDefaultSectionContent(
          hydratedPage.current.content,
          FOOTER_SECTION_ID
        );
      }

      acc[hydratedPage.id] = hydratedPage;
      return acc;
    },
    {}
  );

  const referenceContent = getBestFooterReferenceContent(
    Object.values(hydratedPages)
  );

  if (!referenceContent) {
    return hydratedPages;
  }

  Object.keys(hydratedPages).forEach(pageId => {
    const hydratedPage = hydratedPages[pageId];
    if (!isContentLoaded(hydratedPage.current)) return;

    hydratedPages[pageId] = {
      ...hydratedPage,
      current: normalizePageFooterContent(
        hydratedPage.current,
        referenceContent
      ),
    };
  });

  return hydratedPages;
};

const ensureChildInParent = (
  content: Record<string, any>,
  parentId: string,
  childId: string
) => {
  if (!content[parentId]) return;
  const parentChildren = Array.isArray(content[parentId].children)
    ? [...content[parentId].children]
    : [];
  if (parentChildren.includes(childId)) return;
  content[parentId] = {
    ...content[parentId],
    children: [...parentChildren, childId],
  };
};

const normalizeDefaultSectionContent = (
  content: Record<string, any>,
  sectionId: string
) => {
  const sectionWidget = content[sectionId];
  if (!sectionWidget?.config) return;

  content[sectionId] = {
    ...sectionWidget,
    config: {
      ...sectionWidget.config,
      parentId: 'root',
    },
  };

  Object.keys(content).forEach(widgetId => {
    if (widgetId === 'root' || widgetId === sectionId) return;
    const widget = content[widgetId];
    if (!widget) return;

    if (Array.isArray(widget.children) && widget.children.includes(sectionId)) {
      content[widgetId] = {
        ...widget,
        children: widget.children.filter((id: string) => id !== sectionId),
      };
    }
  });

  ensureChildInParent(content, 'root', sectionId);

  const claimedChildren = Array.isArray(content[sectionId]?.children)
    ? content[sectionId].children
    : [];
  const directChildren = Object.keys(content).filter(widgetId => {
    if (widgetId === 'root' || widgetId === sectionId) return false;
    return content[widgetId]?.config?.parentId === sectionId;
  });

  const validClaimedChildren = claimedChildren.filter((childId: string) => {
    const child = content[childId];
    if (!child || childId === sectionId) return false;

    const childParentId = child?.config?.parentId;
    if (childParentId && childParentId !== sectionId) return false;

    content[childId] = {
      ...child,
      config: {
        ...(child.config || {}),
        parentId: sectionId,
      },
    };
    return true;
  });

  content[sectionId] = {
    ...content[sectionId],
    children: Array.from(new Set([...validClaimedChildren, ...directChildren])),
  };
};

const normalizePageFooterContent = (
  pageVersion: PageVersion,
  referenceContent?: Record<string, any>
): PageVersion => {
  return normalizePageSectionContent<PageVersion>(
    pageVersion,
    referenceContent,
    FOOTER_SECTION_ID,
    content => {
      normalizeDefaultSectionContent(content, HEADER_SECTION_ID);
      normalizeDefaultSectionContent(content, FOOTER_SECTION_ID);
    }
  );
};

const getBestFooterReferenceContent = (
  pages: Array<PageVersion | Page | undefined>,
  excludePageId?: number
): Record<string, any> | undefined => {
  return getBestSectionReferenceContent(
    pages.filter(page => {
      if (!page) return false;
      if ('current' in page) {
        return page.current?.content !== templates[0].widgets;
      }
      return page.content !== templates[0].widgets;
    }),
    FOOTER_SECTION_ID,
    excludePageId
  );
};

export const cannotAddToDefaultSections = [
  widgetTypes.AccordionWidget,
  widgetTypes.Banner,
  widgetTypes.Slideshow,
  widgetTypes.Tabs,
  widgetTypes.Form,
  widgetTypes.Card,
  widgetTypes.Application,
];

/**
 * Applies a widget configuration update to the current page or cascades a
 * default-widget update across the site's loaded pages.
 *
 * @param state - Current sites reducer state.
 * @param action - Widget configuration update action.
 * @returns The state containing the updated widget configuration.
 */
const updateWidgetConfigInState = (state: State, action: AnyAction): State => {
  let updatedState = { ...state };

  if (action.widgetId === 'root') {
    return updatedState;
  }

  if (!action.defaultWidget) {
    return withWidget(
      updatedState,
      action.siteId,
      action.pageId,
      action.widgetId,
      widget => ({
        ...widget,
        config: action.config,
      })
    );
  }

  const sitePages = state.data.find(site => site.siteId === action.siteId)
    ?.pages;
  if (!sitePages) {
    return state;
  }

  const currentPage = sitePages[action.pageId].current;
  const updatedConfigXLocation = action.config.xLocation;
  const updatedConfigYLocation = action.config.yLocation;
  const oldConfigXLocation =
    currentPage.content[action.widgetId].config.xLocation;
  const oldConfigYLocation =
    currentPage.content[action.widgetId].config.yLocation;
  const changeInLocation =
    oldConfigXLocation !== updatedConfigXLocation ||
    oldConfigYLocation !== updatedConfigYLocation;

  if (action.widgetId === FOOTER_SECTION_ID && changeInLocation) {
    return updateDefaultWidget(
      updatedState,
      action.siteId,
      action.pageId,
      action.widgetId,
      widget => ({
        ...widget,
        config: action.config,
      })
    );
  }

  if (action.widgetId === HEADER_SECTION_ID && changeInLocation) {
    return updatedState;
  }

  Object.keys(sitePages).forEach(index => {
    let xLocationToUse = updatedConfigXLocation;
    let yLocationToUse = updatedConfigYLocation;

    if (parseInt(index, 10) !== action.pageId) {
      const widgetOnOtherPage =
        sitePages[index]?.current.content[action.widgetId];
      if (!widgetOnOtherPage) return;

      const xDifference = updatedConfigXLocation - oldConfigXLocation;
      const yDifference = updatedConfigYLocation - oldConfigYLocation;
      xLocationToUse = widgetOnOtherPage.config.xLocation + xDifference;
      yLocationToUse = widgetOnOtherPage.config.yLocation + yDifference;
    }

    const updatedConfig = {
      ...action.config,
      xLocation: xLocationToUse,
      yLocation: yLocationToUse,
    };
    updatedState = updateDefaultWidget(
      updatedState,
      action.siteId,
      parseInt(index, 10),
      action.widgetId,
      widget => ({
        ...widget,
        config: updatedConfig,
      })
    );
  });

  return updatedState;
};

/**
 * Reducer
 */
const reducer: Reducer<State> = (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_WIDGET_POSITION:
      return withCurrentPageVersion(
        state,
        action.siteId,
        action.pageId,
        page => {
          // Sticky-bottom banners are fixed to the viewport and do not push
          // page content down, so skip the margin adjustment entirely.
          const bannerWidget = page.content[action.bannerWidgetId];
          // Skip margin shift only when the banner remains sticky after this action.
          const effectivePlacement =
            action.newPlacement ?? bannerWidget?.config?.placement;
          if (effectivePlacement === 'Sticky Bottom (Fixed to Screen)') {
            return page;
          }

          const headerChildren =
            page.content[HEADER_SECTION_ID]?.children || [];
          // Banner's own children move with the banner; exclude them from the shift.
          const bannerChildren = bannerWidget?.children ?? [];
          const rootWidgetIds = Object.keys(page.content).filter(
            id =>
              id !== 'root' &&
              id !== action.bannerWidgetId &&
              !bannerChildren.includes(id) &&
              !headerChildren.includes(id) &&
              id !== HEADER_SECTION_ID
          );
          const updatedContent = { ...page.content };
          rootWidgetIds.forEach(id => {
            const widget = updatedContent[id];
            const config = widget.config || {};
            const currentMargin = config.marginTop ?? 0;
            const previousBannerHeight = config.appliedBannerHeight ?? 0;
            const heightDiff = action.height - previousBannerHeight;
            const newMargin = Math.max(0, currentMargin + heightDiff);
            config.marginTop = newMargin;
            config.appliedBannerHeight = action.height;
            widget.config = config;
          });

          return {
            ...page,
            content: {
              ...page.content,
              ...updatedContent,
            },
          };
        }
      );

    case CREATE_SITE_PENDING:
      return {
        ...state,
        createSiteMeta: { ...state.createSiteMeta, pending: true },
      };
    case CREATE_SITE_FAILED:
      return {
        ...state,
        createSiteMeta: {
          ...state.createSiteMeta,
          pending: false,
          successful: false,
        },
      };
    case CREATE_SITE_FULFILLED:
      return {
        ...state,
        createSiteMeta: {
          ...state.createSiteMeta,
          pending: false,
          successful: true,
        },
        data: state.data.concat({
          ...(action.site as Site),
          pages: {},
          siteProvisioningStores: [],
          prevSiteProvisioningStores: [],
          meta: {},
        }),
        newSiteId: action.site.siteId,
      };
    case ADD_CHILD: {
      const newWidgetId = action.widgetId || uuidv4();
      let updatedStateAddChild = { ...state };
      withCurrentPageVersion(state, action.siteId, action.pageId, page => {
        const headerSectionWidgetConfig =
          page.content[HEADER_SECTION_ID]?.config;
        const footerSectionWidgetConfig =
          page.content[FOOTER_SECTION_ID]?.config;
        const currentWidgetConfig = {
          visible: true,
          ...action.initialConfig,
          parentId: action.parentWidgetId,
        };

        // Helper to check if parent is descendant of header/footer
        const isDescendantOfDefaultSection = (parentId: string): boolean => {
          if (!parentId) return false;
          if (parentId === HEADER_SECTION_ID || parentId === FOOTER_SECTION_ID)
            return true;
          const parent = page.content[parentId];
          if (!parent) return false;
          return isDescendantOfDefaultSection(parent.config?.parentId);
        };

        const isDefaultSectionDescendant =
          !cannotAddToDefaultSections.includes(action.widgetType) &&
          page.content[action.parentWidgetId]?.defaultWidget &&
          (isDescendantOfDefaultSection(action.parentWidgetId) ||
            action.parentWidgetId === HEADER_SECTION_ID ||
            action.parentWidgetId === FOOTER_SECTION_ID);

        if (
          isDefaultSectionDescendant &&
          headerSectionWidgetConfig &&
          footerSectionWidgetConfig
        ) {
          const sitePages = state.data.find(
            site => site.siteId === action.siteId
          )?.pages;
          if (!sitePages) return page;

          const canonicalPageContent = page.content;
          const canonicalHeaderConfig =
            canonicalPageContent[HEADER_SECTION_ID]?.config;
          const canonicalFooterConfig =
            canonicalPageContent[FOOTER_SECTION_ID]?.config;

          let canonicalSectionId = null;
          let tempParentId = action.parentWidgetId;
          while (tempParentId && tempParentId !== 'root') {
            if (tempParentId === HEADER_SECTION_ID) {
              canonicalSectionId = HEADER_SECTION_ID;
              break;
            }
            if (tempParentId === FOOTER_SECTION_ID) {
              canonicalSectionId = FOOTER_SECTION_ID;
              break;
            }
            tempParentId = page.content[tempParentId]?.config?.parentId;
          }

          Object.keys(sitePages).forEach(index => {
            const indexPageId = parseInt(index, 10);
            // Skip placeholder pages — they haven't been fetched from the server
            // yet.  Cascading into them would corrupt the reference equality
            // check (content !== templates[0].widgets) used by filterValidPages,
            // causing the page to render with template content + the new widget.
            // FETCH_PAGE_FULFILLED already propagates defaultWidget changes from
            // a ref page when the placeholder is eventually fetched.
            if (!isContentLoaded(sitePages[indexPageId].current)) {
              return;
            }
            const targetPageContent = sitePages[indexPageId].current.content;

            let updatedConfigForChildWidget = { ...currentWidgetConfig };

            if (
              canonicalSectionId === HEADER_SECTION_ID &&
              canonicalHeaderConfig
            ) {
              // Header descendant: compute relative to canonical header
              const canonicalHeaderY = canonicalHeaderConfig.yLocation;
              const canonicalHeaderX = canonicalHeaderConfig.xLocation || 0;
              const targetHeaderY =
                targetPageContent[HEADER_SECTION_ID]?.config.yLocation || 0;
              const targetHeaderX =
                targetPageContent[HEADER_SECTION_ID]?.config.xLocation || 0;
              const relY = currentWidgetConfig.yLocation - canonicalHeaderY;
              const relX = currentWidgetConfig.xLocation - canonicalHeaderX;
              updatedConfigForChildWidget = {
                ...currentWidgetConfig,
                yLocation: targetHeaderY + relY,
                xLocation: targetHeaderX + relX,
              };
            } else if (
              canonicalSectionId === FOOTER_SECTION_ID &&
              canonicalFooterConfig
            ) {
              // Footer descendant: compute relative to canonical footer + banner diff
              const canonicalFooterY = canonicalFooterConfig.yLocation;
              const canonicalFooterX = canonicalFooterConfig.xLocation || 0;
              const targetFooterY =
                targetPageContent[FOOTER_SECTION_ID]?.config.yLocation || 0;
              const targetFooterX =
                targetPageContent[FOOTER_SECTION_ID]?.config.xLocation || 0;
              const relY = currentWidgetConfig.yLocation - canonicalFooterY;
              const relX = currentWidgetConfig.xLocation - canonicalFooterX;

              // Banner height adjustment
              const getBannerHeight = (content: any) => {
                const bannerId = Object.keys(content).find(
                  id => content[id]?.type === widgetTypes.Banner
                );
                return bannerId ? content[bannerId].config?.height || 0 : 0;
              };
              const canonicalBannerHeight = getBannerHeight(
                canonicalPageContent
              );
              const targetBannerHeight = getBannerHeight(targetPageContent);
              const bannerDiff = targetBannerHeight - canonicalBannerHeight;

              updatedConfigForChildWidget = {
                ...currentWidgetConfig,
                yLocation: targetFooterY + relY + bannerDiff,
                xLocation: targetFooterX + relX,
              };
            }
            updatedStateAddChild = withCurrentPageVersion(
              updatedStateAddChild,
              action.siteId,
              parseInt(index, 10),
              indexPage => {
                return {
                  ...indexPage,
                  content: {
                    ...indexPage.content,
                    [action.parentWidgetId]: {
                      ...indexPage.content[action.parentWidgetId],
                      children: [
                        ...indexPage.content[
                          action.parentWidgetId
                        ].children.slice(0, action.location),
                        newWidgetId,
                        ...indexPage.content[
                          action.parentWidgetId
                        ].children.slice(action.location),
                      ],
                    },
                    [newWidgetId]: {
                      id: newWidgetId,
                      type: action.widgetType,
                      config: updatedConfigForChildWidget,
                      children: [],
                      defaultWidget: true,
                      tabIndex:
                        action.tabIndex !== undefined ? action.tabIndex : -1,
                    },
                  },
                };
              }
            );
          });
        } else
          updatedStateAddChild = withCurrentPageVersion(
            updatedStateAddChild,
            action.siteId,
            action.pageId,
            page => {
              return {
                ...page,
                forms: {
                  ...page?.forms,
                  create:
                    action.widgetType === widgetTypes.Form
                      ? [...(page?.forms?.create || []), newWidgetId]
                      : [...(page?.forms?.create || [])],
                },
                content: {
                  ...page.content,
                  [action.parentWidgetId]: {
                    ...page.content[action.parentWidgetId],
                    children: [
                      ...page.content[action.parentWidgetId].children.slice(
                        0,
                        action.location
                      ),
                      newWidgetId,
                      ...page.content[action.parentWidgetId].children.slice(
                        action.location
                      ),
                    ],
                  },
                  [newWidgetId]: {
                    id: newWidgetId,
                    type: action.widgetType,
                    config: action.initialConfig,
                    children: [],
                    tabIndex:
                      action.tabIndex !== undefined ? action.tabIndex : -1,
                  },
                },
              };
            }
          );
        return {
          ...page,
          content: {
            ...page.content,
            [action.parentWidgetId]: {
              ...page.content[action.parentWidgetId],
              children: [
                ...page.content[action.parentWidgetId].children.slice(
                  0,
                  action.location
                ),
                newWidgetId,
                ...page.content[action.parentWidgetId].children.slice(
                  action.location
                ),
              ],
            },
            [newWidgetId]: {
              id: newWidgetId,
              type: action.widgetType,
              config: action.initialConfig,
              children: [],
              tabIndex: action.tabIndex !== undefined ? action.tabIndex : -1,
            },
          },
        };
      });
      return updatedStateAddChild;
    }
    case ADD_SIBLING: {
      const newSiblingId = action.newWidgetId || uuidv4();
      let updatedStateAddSibling = { ...state };
      withCurrentPageVersion(state, action.siteId, action.pageId, page => {
        let parentId: string = Object.keys(page.content).find((key: string) => {
          return page.content[key].children.includes(action.siblingWidgetId);
        });
        let location: number =
          page.content[parentId].children?.indexOf(action.siblingWidgetId) + 1;
        if (page.content[action.siblingWidgetId].defaultWidget) {
          const sitePages = state.data.find(
            site => site.siteId === action.siteId
          )?.pages;
          if (!sitePages) return page;
          Object.keys(sitePages).forEach(index => {
            // Skip placeholder pages — same reason as the ADD_CHILD guard.
            // Spreading templates[0].widgets breaks the sentinel reference check
            // used by FETCH_PAGE_FULFILLED and filterValidPages.
            if (!isContentLoaded(sitePages[parseInt(index, 10)].current)) {
              return;
            }
            //get sibling widget from the page
            updatedStateAddSibling = withCurrentPageVersion(
              updatedStateAddSibling,
              action.siteId,
              parseInt(index, 10),
              indexPage => {
                parentId = Object.keys(indexPage.content).find(
                  (key: string) => {
                    return indexPage.content[key].children.includes(
                      action.siblingWidgetId
                    );
                  }
                );
                const siblingWidget = indexPage.content[action.siblingWidgetId];
                location =
                  indexPage.content[parentId].children?.indexOf(
                    action.siblingWidgetId
                  ) + 1;
                return {
                  ...indexPage,
                  content: {
                    ...indexPage.content,
                    [parentId]: {
                      ...indexPage.content[parentId],
                      children: [
                        ...indexPage.content[parentId].children.slice(
                          0,
                          location
                        ),
                        newSiblingId,
                        ...indexPage.content[parentId].children.slice(location),
                      ],
                    },
                    [newSiblingId]: {
                      id: newSiblingId,
                      type: action.widgetType,
                      config: {
                        ...action.config,
                        xLocation: siblingWidget.config.xLocation + 10,
                        yLocation: siblingWidget.config.yLocation + 10,
                        parentId: parentId,
                      },
                      defaultWidget: true,
                      children: action.children || [],
                      tabIndex:
                        action.tabIndex !== undefined ? action.tabIndex : -1,
                    },
                  },
                };
              }
            );
            // }
          });
        } else
          updatedStateAddSibling = withCurrentPageVersion(
            updatedStateAddSibling,
            action.siteId,
            action.pageId,
            page => {
              return {
                ...page,
                content: {
                  ...page.content,
                  [parentId]: {
                    ...page.content[parentId],
                    children: [
                      ...page.content[parentId].children.slice(0, location),
                      newSiblingId,
                      ...page.content[parentId].children.slice(location),
                    ],
                  },
                  [newSiblingId]: {
                    id: newSiblingId,
                    type: action.widgetType,
                    config: {
                      ...action.config,
                      xLocation:
                        page.content[action.siblingWidgetId].config.xLocation +
                        10,
                      yLocation:
                        page.content[action.siblingWidgetId].config.yLocation +
                        10,
                    },
                    children: action.children || [],
                    tabIndex:
                      action.tabIndex !== undefined ? action.tabIndex : -1,
                  },
                },
              };
            }
          );
        return {
          ...page,
          forms: {
            ...page?.forms,
            create:
              action.widgetType === widgetTypes.Form
                ? [...(page?.forms?.create || []), newSiblingId]
                : [...(page?.forms?.create || [])],
          },
          content: {
            ...page.content,
            [parentId]: {
              ...page.content[parentId],
              children: [
                ...page.content[parentId].children.slice(0, location),
                newSiblingId,
                ...page.content[parentId].children.slice(location),
              ],
            },
            [newSiblingId]: {
              id: newSiblingId,
              type: action.widgetType,
              config: action.config,
              children: action.children || [],
              tabIndex: action.tabIndex !== undefined ? action.tabIndex : -1,
            },
          },
        };
      });
      return updatedStateAddSibling;
    }
    case ADOPT_CHILD:
      return withCurrentPageVersion(
        state,
        action.siteId,
        action.pageId,
        page => ({
          ...page,
          forms: {
            ...page?.forms,
            create:
              action.widgetType === widgetTypes.Form
                ? [...(page?.forms?.create || []), action.childWidgetId]
                : [...(page?.forms?.create || [])],
          },
          content: Object.keys(page.content).reduce((acc, key) => {
            const children = page.content[key].children.filter(
              id => id !== action.childWidgetId
            );
            acc[key] = {
              ...page.content[key],
              children:
                action.parentWidgetId === key
                  ? [
                      ...children.slice(0, action.location),
                      action.childWidgetId,
                      ...children.slice(action.location),
                    ]
                  : children,
            };
            return acc;
          }, {} as any),
        })
      );
    case UPDATE_WIDGET_CONFIG: {
      return updateWidgetConfigInState(state, action);
    }
    case UPDATE_CURRENT_PAGE_WIDGET_CONFIG:
      if (action.widgetId !== 'root') {
        return withWidget(
          state,
          action.siteId,
          action.pageId,
          action.widgetId,
          widget => ({
            ...widget,
            config: action.config,
            defaultWidget: false,
          })
        );
      }
      return state;
    case BATCH_UPDATE_REPEATER_WIDGETS: {
      let updatedState = { ...state };

      // Batch update all widgets in a single reducer operation
      action.widgetUpdates.forEach(
        (update: { widgetId: string; config: any }) => {
          if (update.widgetId !== 'root') {
            updatedState = withWidget(
              updatedState,
              action.siteId,
              action.pageId,
              update.widgetId,
              widget => ({
                ...widget,
                config: update.config,
                defaultWidget: false,
              })
            );
          }
        }
      );

      return updatedState;
    }
    case REMOVE_WIDGET: {
      return withCurrentPageVersion(
        state,
        action.siteId,
        action.pageId,
        page => {
          return {
            ...page,
            forms: {
              delete: [
                ...(page?.forms?.delete || []),
                ...(!page?.forms?.create?.filter(
                  widgetId => widgetId === action.widgetId
                ).length
                  ? [action.widgetId]
                  : []),
              ],
              create: page?.forms?.create?.filter(
                widgetId => widgetId !== action.widgetId
              ) || [...(page?.forms?.create || [])],
              update: page?.forms?.update?.filter(
                widgetId => widgetId !== action.widgetId
              ) || [...(page?.forms?.update || [])],
            },
            content: Object.keys(page.content)
              .filter(key => key !== action.widgetId)
              .reduce((acc, key) => {
                acc[key] = {
                  ...page.content[key],
                  children: page.content[key].children.filter(
                    id => id !== action.widgetId
                  ),
                };
                return acc;
              }, {} as any),
          };
        }
      );
    }
    case CHANGE_WIDGET_VISIBLE: {
      return withCurrentPageVersion(
        state,
        action.siteId,
        action.pageId,
        page => {
          const updatedContent = { ...page.content };
          function getParent(widget) {
            if (!widget?.config?.parentId) return undefined;
            return updatedContent[widget.config.parentId];
          }

          function computeVisibility(widgetId: string): boolean {
            const widget = updatedContent[widgetId];
            const parent = getParent(widget);
            if (!parent) {
              return widget.config.visible !== false;
            }
            // check parent's index and visibility
            if (
              parent.type === widgetTypes.Tabs ||
              parent.type === widgetTypes.AccordionWidget ||
              parent.type === widgetTypes.Slideshow ||
              (parent.type === widgetTypes.Navigation &&
                parent.config?.style === 'Vertical')
            ) {
              let parentIndex;
              if (parent.type === widgetTypes.Slideshow) {
                parentIndex = parent.config.currentSlideIndex;
              } else if (
                parent.type === widgetTypes.Navigation &&
                parent.config?.style === 'Vertical'
              ) {
                // Use dispatched tab index when provided to avoid stale parent config reads.
                parentIndex =
                  parent.id === action.parentWidgetId &&
                  action.currentTabIndex !== undefined
                    ? action.currentTabIndex
                    : parent.config.currentMenuItem;
              } else {
                parentIndex = parent.config.currentTabIndex;
              }
              // for Accordion: if currentTabIndex is null/undefined, no panel is open, so all children should be hidden
              if (
                parent.type === widgetTypes.AccordionWidget &&
                (parentIndex === null || parentIndex === undefined)
              ) {
                return false;
              }
              if (
                typeof parentIndex !== 'number' &&
                typeof parentIndex !== 'string'
              ) {
                parentIndex = 0;
              }
              return (
                computeVisibility(parent.id) && parentIndex === widget.tabIndex
              );
            }
            // default: inherit parent's visibility
            return computeVisibility(parent.id);
          }

          // recursively update visibility for widget and its descendants
          function updateVisibilityRecursively(widgetId: string) {
            const widget = updatedContent[widgetId];
            if (!widget) return;
            widget.config.visible = computeVisibility(widgetId);
            if (widget.children && widget.children.length > 0) {
              widget.children.forEach(childId =>
                updateVisibilityRecursively(childId)
              );
            }
          }
          // always update all children of the parent widget, not just the parent itself
          if (updatedContent[action.parentWidgetId]) {
            updateVisibilityRecursively(action.parentWidgetId);
            // also update all descendants (children, grandchildren, etc.)
            const parentWidget = updatedContent[action.parentWidgetId];
            if (parentWidget.children && parentWidget.children.length > 0) {
              parentWidget.children.forEach(childId =>
                updateVisibilityRecursively(childId)
              );
            }
          }
          return {
            ...page,
            content: {
              ...updatedContent,
            },
          };
        }
      );
    }
    case UPDATE_PAGE_CONTENT:
      return withSite(state, action.siteId, site => {
        const normalizedPage = applyInlineBannerMarginsToPage(
          action.page?.page
        );
        return {
          ...site,
          pages: {
            ...site.pages,
            [action.pageId]: normalizedPage,
          },
        };
      });
    case FETCH_SITE_PENDING:
    case FETCH_SITES_BY_UUID_PENDING:
    case FETCH_SITES_PENDING:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: true,
        },
      };
    case FETCH_SITES_FULFILLED:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: false,
          successful: true,
        },
        data: (action.sites as Array<Site>).map(site => ({
          ...site,
          pages: {},
          meta: {},
          prevSiteProvisioningStores: site.siteProvisioningStores,
        })),
      };
    case FETCH_SITES_BY_UUID_FAILED:
    case FETCH_SITE_FAILED:
    case FETCH_SITES_FAILED:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: false,
          successful: false,
        },
      };
    case FETCH_SITES_BY_UUID_FULFILLED:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: false,
          successful: true,
        },
        data: (action.sites as Array<Site>).map(site => ({
          ...site,
          tenancy: {
            tenantId: site['tenantId'],
          },
          pages: {},
          meta: {},
          prevSiteProvisioningStores: site.siteProvisioningStores,
        })),
      };
    case FETCH_SITE_FULFILLED:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: false,
          successful: true,
        },
        data: state.data.map(site => {
          if (site.siteId === action.site.siteId) {
            return {
              ...action.site,
              prevSiteProvisioningStores: site.siteProvisioningStores,
            };
          }
          return site;
        }),
      };
    case FETCH_PAGES_PENDING:
    case FETCH_PAGES_BY_TIME_PENDING:
      return withSite(state, action.siteId, site => ({
        ...site,
        meta: {
          ...site.meta,
          pending: true,
        },
      }));
    case FETCH_PAGES_BY_TIME_FULFILLED:
      return withSite(state, action.siteId, site => ({
        ...site,
        pages: hydrateFetchedPages(action.pages),
        meta: {
          ...site.meta,
          pending: false,
          successful: true,
        },
      }));
    case FETCH_PAGES_FAILED:
    case FETCH_PAGES_BY_TIME_FAILED:
      return withSite(state, action.siteId, site => ({
        ...site,
        meta: {
          ...site.meta,
          pending: false,
          successful: false,
        },
      }));
    case FETCH_PAGES_FULFILLED:
      return withSite(state, action.siteId, site => {
        const incoming = hydrateFetchedPages(action.pages);
        // Preserve content that was already fetched in a prior session.
        // fetchPages is called every time SiteRouter mounts, but it only
        // returns page metadata — content comes back null and gets replaced
        // with the placeholder sentinel in hydrateFetchedPages.  Without this
        // merge, re-entering the editor discards all previously-loaded content
        // and forces every page to re-fetch, causing the loading overlay.
        Object.keys(incoming).forEach(id => {
          const existing = site.pages[id];
          if (existing?.current?.content && isContentLoaded(existing.current)) {
            incoming[id] = {
              ...incoming[id],
              current: {
                ...incoming[id].current,
                content: existing.current.content,
                loadState: 'loaded' as const,
              },
            };
          }
        });
        return {
          ...site,
          pages: incoming,
          meta: { ...site.meta, pending: false, successful: true },
        };
      });
    case FETCH_PAGE_FULFILLED: {
      // Deep-copy so we don't mutate the action payload.
      const incomingPage = {
        ...action.page,
        current: {
          ...action.page.current,
          content: { ...action.page.current.content },
          loadState: 'loaded' as const,
        },
      };
      // Some pages were saved to the DB without a root widget. Reconstruct it
      // here so ADD_CHILD and canvas rendering don't crash on these pages.
      // root.children = all widget IDs whose parentId is absent (top-level canvas widgets).
      if (
        incomingPage.current.content &&
        !incomingPage.current.content['root']
      ) {
        const { content } = incomingPage.current;
        const rootChildren = Object.keys(content).filter(
          id => !content[id]?.config?.parentId
        );
        incomingPage.current.content['root'] = {
          id: 'root',
          type: 'List',
          config: { bgcolor: 'transparent' },
          children: rootChildren,
          permanent: true,
          defaultWidget: true,
        };
      }
      normalizeDefaultSectionContent(
        incomingPage.current.content,
        HEADER_SECTION_ID
      );
      normalizeDefaultSectionContent(
        incomingPage.current.content,
        FOOTER_SECTION_ID
      );
      // Guard: if the user already edited defaultWidgets (header/footer) on
      // another page before this fetch completed, apply those edits here so
      // the concurrent-load race condition doesn't silently lose changes.
      const incomingPageId = action.page.id;
      const currentSite = state.data.find(s => s.siteId === action.siteId);
      // Preserve unsaved local changes: if the page already has real
      // (non-placeholder) content in Redux state, keep it instead of
      // overwriting with the server response.  This prevents a background
      // stale-while-revalidate fetch (triggered on navigation) from clobbering
      // widgets the user added but hasn't saved yet.
      // Concurrent edits by another user are still detected within ~5 s via
      // the autosave fetchCompareSiteandPage interval, which triggers
      // UserSyncChangesDialog independently of this path.
      const existingPage = currentSite?.pages[incomingPageId];
      if (
        existingPage?.current?.content &&
        isContentLoaded(existingPage.current)
      ) {
        // Shallow-clone so that the subsequent defaultWidget propagation
        // mutations below do not directly mutate the existing Redux state object.
        incomingPage.current.content = { ...existingPage.current.content };
      }
      if (currentSite) {
        const refPage = Object.values(currentSite.pages).find(
          (p: any) =>
            p.id !== incomingPageId &&
            p.current?.content &&
            isContentLoaded(p.current)
        ) as any;
        if (refPage) {
          const refContent = refPage.current.content;

          Object.keys(refContent).forEach(widgetId => {
            // Only propagate header/footer sections and their descendants —
            // not root itself.  root.defaultWidget = true but root's children
            // array includes page-specific widgets; propagating root would
            // copy canvas-level widgets from the ref page onto every fetched page.
            if (refContent[widgetId]?.defaultWidget && widgetId !== 'root') {
              const refWidget = refContent[widgetId];
              // Always propagate the in-memory ref page's header/footer —
              // header/footer is site-wide and the ref page is the authoritative
              // source for the current session's state, regardless of child count.
              // Removing the child count guard fixes the case where a user edits
              // the header (e.g. removes nav links) and unvisited pages revert
              // to the old default header because the old DB version had more
              // children than the edited in-memory version.
              //
              // EXCEPTION: footer yLocation is page-specific (AGENTS.md).
              // Preserve the incoming page's own footer yLocation so navigating
              // from page 1 (yLocation=1759) to page 2 (yLocation=830) does not
              // overwrite page 2's footer container position with page 1's value.
              if (widgetId === FOOTER_SECTION_ID) {
                const existingFooterY =
                  incomingPage.current.content[FOOTER_SECTION_ID]?.config
                    ?.yLocation;
                incomingPage.current.content[widgetId] =
                  existingFooterY !== undefined
                    ? {
                        ...refWidget,
                        config: {
                          ...refWidget.config,
                          yLocation: existingFooterY,
                        },
                      }
                    : refWidget;
              } else {
                incomingPage.current.content[widgetId] = refWidget;
              }
              // Also copy any child widgets referenced in the propagated
              // widget's children that are missing from the incoming page.
              // Without this, the incoming page has orphaned child references
              // after propagation (the section lists them but they don't
              // exist in the content map).
              refWidget.children?.forEach((childId: string) => {
                if (
                  refContent[childId] &&
                  !incomingPage.current.content[childId]
                ) {
                  incomingPage.current.content[childId] = refContent[childId];
                }
              });
            }
          });
          // Re-canonicalize after cross-page defaultWidget propagation so
          // header/footer children arrays and parentId back-refs stay
          // consistent with the widgets we just copied in from refContent.
          normalizeDefaultSectionContent(
            incomingPage.current.content,
            HEADER_SECTION_ID
          );
          normalizeDefaultSectionContent(
            incomingPage.current.content,
            FOOTER_SECTION_ID
          );
        }

        const footerReferenceContent = getBestFooterReferenceContent(
          Object.values(currentSite.pages) as Page[],
          incomingPageId
        );

        if (footerReferenceContent) {
          incomingPage.current = normalizePageFooterContent(
            incomingPage.current,
            footerReferenceContent
          );
        }
      }
      // Normalize page references (slim down selectedPage / pageSelected).
      // hydrateFetchedPages does this for batch fetches (FETCH_PAGES_FULFILLED)
      // but individual fetches via fetchPage bypass that path.  Pages saved
      // before the slim-reference fix still carry full 7–8 MB Page objects;
      // without normalizing here they would be written back to the DB unchanged
      // on the next save, keeping the payload inflated indefinitely.
      // We deep-clone first so refPage widget references propagated above are
      // not mutated in-place (which would corrupt the reference page's state).
      if (incomingPage.current.content) {
        const availablePages = currentSite
          ? (Object.values(currentSite.pages) as Page[]).filter(
              (p: any) => p?.current?.content && isContentLoaded(p.current)
            )
          : [];
        const pageLookup = buildPageLookup(availablePages);
        incomingPage.current.content = _.cloneDeep(
          incomingPage.current.content
        );
        normalizePageReferencesInContent(
          incomingPage.current.content,
          pageLookup
        );
      }
      return withPage(state, action.siteId, incomingPageId, () => incomingPage);
    }
    case CREATE_PAGE_FULFILLED:
      if (!action.page) {
        return state;
      }
      return withSite(state, action.siteId, site => ({
        ...site,
        pages: {
          ...site.pages,
          [action.page.id]: action.page,
        },
      }));
    case SAVE_PAGE_FULFILLED:
      // The v4 PUT response (PageVersions_SimpleWithAccess) omits content and
      // pageBackground.  Merge the response metadata on top of the existing
      // current version so those fields are never lost from state.
      return withPage(state, action.siteId, action.pageId, page => ({
        ...page,
        current: {
          ...page.current,
          ...action.newVersion,
          content: action.newVersion?.content ?? page.current?.content,
          pageBackground:
            action.newVersion?.pageBackground ?? page.current?.pageBackground,
        },
      }));
    // save all pages in a site
    case SAVE_ALL_PAGE_FULFILLED:
      return withSite(state, action.siteId, site => ({
        ...site,
        pages: Object.keys(site.pages).reduce((acc, key) => {
          const existingPage = site.pages[key];
          const savedVersion = action.newVersions[key];
          acc[key] = {
            ...existingPage,
            current: {
              ...existingPage.current,
              ...savedVersion,
              content: savedVersion?.content ?? existingPage.current?.content,
              pageBackground:
                savedVersion?.pageBackground ??
                existingPage.current?.pageBackground,
            },
          };
          return acc;
        }, {}),
      }));
    case REMOVE_PAGE_FULFILLED:
      return withSite(state, action.siteId, site => ({
        ...site,
        pages: Object.keys(site.pages)
          .map(key => parseInt(key, 10))
          .filter(key => key !== action.pageId)
          .reduce((acc, key) => {
            acc[key] = site.pages[key];
            return acc;
          }, {}),
      }));
    case SAVE_SITE_PENDING:
      return {
        ...state,
        saveSiteMeta: {
          pending: true,
          siteId: action.siteId,
        },
      };
    case SAVE_SITE_FULFILLED:
      return {
        ...state,
        data: state.data.map(site => {
          if (site.siteId === action.siteId) {
            return {
              ...site,
              ...action.site,
            };
          }
          return site;
        }),
        saveSiteMeta: {
          pending: false,
          successful: true,
          // populated if save was partially successful but an error occured
          error: action.error,
        },
      };
    case SAVE_SITE_FAILED:
      return {
        ...state,
        saveSiteMeta: {
          pending: false,
          successful: false,
          error: action.error,
          siteId: action.siteId,
        },
      };
    case UNPUBLISH_SITE_FAILED:
    case PUBLISH_SITE_FAILED:
      return {
        ...state,
        publishMeta: {
          ...state.publishMeta,
          pending: false,
          successful: false,
        },
      };
    case PUBLISH_SITE_FULFILLED:
      return {
        ...state,
        publishMeta: { ...state.publishMeta, pending: false, successful: true },
        data: state.data.map(site => {
          if (site.siteId === action.siteId) {
            return {
              ...site,
              published: true,
            };
          }
          return site;
        }),
      };
    case UNPUBLISH_SITE_PENDING:
    case PUBLISH_SITE_PENDING:
      return {
        ...state,
        publishMeta: { ...state.publishMeta, pending: true },
      };
    case UNPUBLISH_SITE_FULFILLED:
      return {
        ...state,
        publishMeta: { ...state.publishMeta, pending: false, successful: true },
        data: state.data.map(site => {
          if (site.siteId === action.siteId) {
            return {
              ...site,
              published: false,
            };
          }
          return site;
        }),
      };
    case ARCHIVE_SITE_FULFILLED:
      return withSite(state, action.siteId, site => ({
        ...site,
        archived: true,
      }));
    case UPDATE_SITE:
      return withSite(state, action.siteId, site => {
        return {
          ...site,
          ...action.site,
          theme: {
            ...site.theme,
            ...action.site?.theme,
          },
          idpHint: action.site?.idpHint || '',
          autoSave: action.site?.autoSave || false,
        };
      });
    case SET_ACTIVE_WIDGET_ID:
      return {
        ...state,
        activeWidgetId: action.widgetId,
      };
    case SET_HOME_PAGE:
      return withSite(state, action.siteId, site => ({
        ...site,
        homepageId: action.pageId,
      }));
    case UPDATE_CURRENT_PAGE:
      return withPage(
        state,
        action.siteId,
        action.currentPage.pageId,
        page => ({
          ...page,
          current: action.currentPage,
        })
      );
    case UPDATE_PAGE_DEFAULT_WIDGET: {
      let updatedStateUpdatePageDefaultWidget = { ...state };
      const sitePages = state.data.find(site => site.siteId === action.siteId)
        ?.pages;
      if (!sitePages) return updatedStateUpdatePageDefaultWidget;
      Object.keys(sitePages).forEach(index => {
        if (parseInt(index, 10) !== action.pageId) {
          const widgetOnOtherPage =
            sitePages[index]?.current?.content[action.widgetId];
          if (!widgetOnOtherPage) return;

          // Footer section yLocation is page-specific per AGENTS.md — do not
          // cascade it to other pages. Footer descendants should continue to
          // move with the shared footer structure across pages.
          const isFooterSection = action.widgetId === FOOTER_SECTION_ID;

          const currentXLocation = widgetOnOtherPage.config.xLocation;
          const currentYLocation = widgetOnOtherPage.config.yLocation;
          const updatedConfig = {
            ...widgetOnOtherPage.config,
            height: action.config.height,
            width: action.config.width,
            xLocation: currentXLocation + action.xDifference,
            yLocation: isFooterSection
              ? currentYLocation
              : currentYLocation + action.yDifference,
          };
          updatedStateUpdatePageDefaultWidget = updateDefaultWidget(
            updatedStateUpdatePageDefaultWidget,
            action.siteId,
            parseInt(index, 10),
            action.widgetId,
            widget => ({
              ...widget,
              config: updatedConfig,
            })
          );
        }
      });
      return updatedStateUpdatePageDefaultWidget;
    }
    case REMOVE_WIDGET_DEFAULT: {
      let updatedStateRemoveWidgetDefault = { ...state };
      withCurrentPageVersion(state, action.siteId, action.pageId, page => {
        const sitePages = state.data.find(site => site.siteId === action.siteId)
          ?.pages;
        if (!sitePages) return page;
        Object.keys(sitePages).forEach(index => {
          if (parseInt(index, 10) !== action.pageId) {
            // Skip placeholder pages — same reason as the ADD_CHILD guard.
            if (!isContentLoaded(sitePages[parseInt(index, 10)].current)) {
              return;
            }
            updatedStateRemoveWidgetDefault = withCurrentPageVersion(
              updatedStateRemoveWidgetDefault,
              action.siteId,
              parseInt(index, 10),
              indexPage => {
                return {
                  ...indexPage,
                  content: Object.keys(indexPage.content)
                    .filter(key => key !== action.widgetId)
                    .reduce((acc, key) => {
                      if (indexPage.content[key].children !== undefined) {
                        acc[key] = {
                          ...indexPage.content[key],
                          children: indexPage.content[key].children.filter(
                            id => id !== action.widgetId
                          ),
                        };
                        return acc;
                      }
                      return acc;
                    }, {} as any),
                };
              }
            );
            // }
          }
        });
        return {
          ...page,
          forms: {
            delete: [
              ...(page?.forms?.delete || []),
              ...(!page?.forms?.create?.filter(
                widgetId => widgetId === action.widgetId
              ).length
                ? [action.widgetId]
                : []),
            ],
            create: page?.forms?.create?.filter(
              widgetId => widgetId !== action.widgetId
            ) || [...(page?.forms?.create || [])],
            update: page?.forms?.update?.filter(
              widgetId => widgetId !== action.widgetId
            ) || [...(page?.forms?.update || [])],
          },
          content: Object.keys(page.content)
            .filter(key => key !== action.widgetId)
            .reduce((acc, key) => {
              acc[key] = {
                ...page.content[key],
                children: page.content[key].children.filter(
                  id => id !== action.widgetId
                ),
              };
              return acc;
            }, {} as any),
        };
      });
      return updatedStateRemoveWidgetDefault;
    }
    case SET_SITE_DATA_FOR_TEMPLATE_EDITING:
      return {
        ...state,
        data: [
          ...state.data,
          {
            ...action.site,
            siteId: action.site.siteId ?? action.site.id,
            pages: action.pages.reduce(
              (acc: { [index: string]: Page }, page: Page) => {
                const { content } = page.current;
                if (content === undefined || content === null) {
                  page.current.content = templateStarter.content;
                }
                acc[page.id] = page;
                return acc;
              },
              {} as any
            ),
            meta: {
              ...action.site.meta,
              pending: false,
              successful: true,
            },
          },
        ],
      };
    case RESET_SITE_DATA_FOR_TEMPLATE_EDITING:
      return {
        ...state,
        data: state.data.filter(site => site.siteId !== TEMPLATES_SITE_ID),
      };
    case NORMALIZE_HEADER_FOOTER:
      return withSite(state, action.siteId, siteSlice => {
        return siteSlice;
      });

    case SET_PENDING_DEFAULT_WIDGET_FETCHES:
      return { ...state, hasPendingDefaultWidgetFetches: action.value };

    default:
      return state;
  }
};

export default reducer;

/**
 * Action creators
 */

export const addChild: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  parentWidgetId: string,
  widgetType: string | FieldType,
  initialConfig: any,
  location: number,
  widgetId?: string,
  tabIndex?: number
) => {
  return {
    type: ADD_CHILD,
    siteId,
    pageId,
    parentWidgetId,
    widgetType,
    initialConfig,
    location,
    widgetId,
    tabIndex,
  };
};

/**
 * Returns the pages map for a given site from the sites slice, or null if the
 * site is not found. Centralises the repeated find-and-access pattern used
 * across thunk action creators.
 */
function getSitePages(
  sitesState: State,
  siteId: number
): SiteSlice['pages'] | null {
  return sitesState.data?.find(s => s.siteId === siteId)?.pages ?? null;
}

/**
 * Dispatches addChild and, when the widget is dropped into a default section
 * (header/footer), background-fetches any placeholder pages so they receive
 * the cascaded change via FETCH_PAGE_FULFILLED and are included in the next
 * save — mirroring the behaviour of updateWidgetConfigAndFetchUnloaded.
 */
export const addChildAndFetchUnloaded: ThunkActionCreator = (
  siteId: number,
  pageId: number,
  parentWidgetId: string,
  widgetType: string | FieldType,
  initialConfig: any,
  location: number,
  widgetId?: string,
  tabIndex?: number
) => (dispatch, getState) => {
  dispatch(
    addChild(
      siteId,
      pageId,
      parentWidgetId,
      widgetType,
      initialConfig,
      location,
      widgetId,
      tabIndex
    )
  );

  // Check whether the drop target is inside a default section (header/footer).
  const pages = getSitePages(getState().sites, siteId);
  if (!pages) return;
  const pageContent = pages[pageId]?.current?.content;
  if (!pageContent) return;

  const isInsideDefaultSection = (startId: string): boolean => {
    let id = startId;
    while (id && id !== 'root') {
      if (id === HEADER_SECTION_ID || id === FOOTER_SECTION_ID) return true;
      id = pageContent[id]?.config?.parentId;
    }
    return false;
  };

  // Only cascade if the parent is a defaultWidget AND inside header/footer.
  const parentIsDefault =
    pageContent[parentWidgetId]?.defaultWidget &&
    isInsideDefaultSection(parentWidgetId);

  if (parentIsDefault) {
    const placeholderPages = (Object.values(pages) as any[]).filter(
      p => p.id !== pageId && !isContentLoaded(p.current)
    );
    if (placeholderPages.length > 0) {
      dispatch({ type: SET_PENDING_DEFAULT_WIDGET_FETCHES, value: true });
      placeholderPages.forEach(p =>
        Promise.resolve(dispatch(fetchPage(siteId, p.id)) as unknown).catch(
          (error: unknown) => {
            dispatch({ type: FETCH_PAGE_FAILED, siteId, pageId: p.id, error });
            console.error(
              'fetchPage background fetch failed for page:',
              p.id,
              error
            );
          }
        )
      );
    }
  }
};

export const updateWidgetPosition: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  bannerWidgetId: string,
  height: number,
  oldHeight: number,
  newPlacement?: string
) => {
  return {
    type: UPDATE_WIDGET_POSITION,
    siteId,
    pageId,
    bannerWidgetId,
    height,
    oldHeight,
    newPlacement,
  };
};

export const addSibling: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  siblingWidgetId: string,
  widgetType: string,
  config: any,
  newWidgetId?: string,
  children?: string[],
  tabIndex?: number
) => {
  return {
    type: ADD_SIBLING,
    siteId,
    pageId,
    siblingWidgetId,
    widgetType,
    config,
    newWidgetId,
    children,
    tabIndex,
  };
};

export const adoptChild: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  parentWidgetId: string,
  childWidgetId: string,
  location: number
) => {
  return {
    type: ADOPT_CHILD,
    siteId,
    pageId,
    parentWidgetId,
    childWidgetId,
    location,
  };
};

export const updateWidgetConfig: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  widgetId: string,
  config: any,
  defaultWidget: boolean
) => {
  return {
    type: UPDATE_WIDGET_CONFIG,
    siteId,
    pageId,
    widgetId,
    config,
    defaultWidget,
  };
};

export const updateCurrentPageWidgetConfig: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  widgetId: string,
  config: any
) => {
  return {
    type: UPDATE_CURRENT_PAGE_WIDGET_CONFIG,
    siteId,
    pageId,
    widgetId,
    config,
  };
};

export const updateDefaultWidgetConfig: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  widgetId: string,
  config: any
) => {
  return {
    type: UPDATE_DEFAULT_WIDGET_CONFIG,
    siteId,
    pageId,
    widgetId,
    config,
  };
};

/**
 * Action creator for batch updating multiple RepeaterWidget children
 * This ensures all related RepeaterWidget updates happen as a single undo operation
 *
 * @param siteId - The site ID
 * @param pageId - The page ID
 * @param widgetUpdates - Array of widget updates with widgetId and config
 * @returns Action object for batch update
 */
export const batchUpdateRepeaterWidgets: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  widgetUpdates: Array<{ widgetId: string; config: any }>
) => {
  return {
    type: BATCH_UPDATE_REPEATER_WIDGETS,
    siteId,
    pageId,
    widgetUpdates,
  };
};

export const removeWidget: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  widgetId: string
) => {
  return { type: REMOVE_WIDGET, siteId, pageId, widgetId };
};

export const removeDefaultWidgets: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  widgetId: string
) => {
  return { type: REMOVE_WIDGET_DEFAULT, siteId, pageId, widgetId };
};

export const updatePageContent: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  page: any
) => {
  return { type: UPDATE_PAGE_CONTENT, siteId, pageId, page };
};

const fetchPagesPending: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: FETCH_PAGES_PENDING, siteId };
};

const fetchPagesFulfilled: ActionCreator<AnyAction> = (
  siteId: number,
  pages: Array<Page>
) => {
  return { type: FETCH_PAGES_FULFILLED, siteId, pages };
};

const fetchPagesFailed: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: FETCH_PAGES_FAILED, siteId };
};

export const createPagePending: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: CREATE_PAGE_PENDING, siteId };
};

const createPageFulfilled: ActionCreator<AnyAction> = (
  siteId: number,
  page: Page
) => {
  return { type: CREATE_PAGE_FULFILLED, siteId, page };
};

export const createPageFailed: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: CREATE_PAGE_FAILED, siteId };
};

export const savePagePending: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number
) => {
  return { type: SAVE_PAGE_PENDING, siteId, pageId };
};

export const savePageFulfilled: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  newVersion: PageVersion
) => {
  return { type: SAVE_PAGE_FULFILLED, siteId, pageId, newVersion };
};

export const savePageFailed: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number
) => {
  return { type: SAVE_PAGE_FAILED, siteId, pageId };
};

export const saveAllPagePending: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: SAVE_ALL_PAGE_PENDING, siteId };
};

export const saveAllPageFulfilled: ActionCreator<AnyAction> = (
  siteId: number,
  newVersions: Array<PageVersion>
) => {
  return { type: SAVE_ALL_PAGE_FULFILLED, siteId, newVersions };
};

export const saveAllPageFailed: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: SAVE_ALL_PAGE_FAILED, siteId };
};

export const removePagePending: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number
) => {
  return { type: REMOVE_PAGE_PENDING, siteId, pageId };
};

export const removePageFulfilled: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number
) => {
  return { type: REMOVE_PAGE_FULFILLED, siteId, pageId };
};

export const removePageFailed: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number
) => {
  return { type: REMOVE_PAGE_FAILED, siteId, pageId };
};

export const setHomePage: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number
) => {
  return { type: SET_HOME_PAGE, siteId, pageId };
};

const fetchSitesPending: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITES_PENDING };
};

const fetchSitesFulfilled: ActionCreator<AnyAction> = (sites: Array<Site>) => {
  return { type: FETCH_SITES_FULFILLED, sites };
};

const fetchSitesFailed: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITES_FAILED };
};

const fetchSitesByUuidPending: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITES_BY_UUID_PENDING };
};

const fetchSitesByUuidFulfilled: ActionCreator<AnyAction> = (
  sites: Array<Site>
) => {
  return { type: FETCH_SITES_BY_UUID_FULFILLED, sites };
};

const fetchSitesByUuidFailed: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITES_BY_UUID_FAILED };
};

const fetchSitePending: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITE_PENDING };
};

const fetchSiteFulfilled: ActionCreator<AnyAction> = (site: Site) => {
  return { type: FETCH_SITE_FULFILLED, site };
};

const fetchSiteFailed: ActionCreator<AnyAction> = () => {
  return { type: FETCH_SITE_FAILED };
};

export const createSitePending: ActionCreator<AnyAction> = () => {
  return { type: CREATE_SITE_PENDING };
};

export const createSiteFulfilled: ActionCreator<AnyAction> = (site: Site) => {
  return { type: CREATE_SITE_FULFILLED, site };
};

export const createSiteFailed: ActionCreator<AnyAction> = () => {
  return { type: CREATE_SITE_FAILED };
};

export const saveSitePending: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: SAVE_SITE_PENDING, siteId };
};

export const saveSiteFulfilled: ActionCreator<AnyAction> = (
  siteId: number,
  site: Site,
  error?: string
) => {
  return { type: SAVE_SITE_FULFILLED, siteId, site, error };
};

export const saveSiteFailed: ActionCreator<AnyAction> = (
  siteId: number,
  error?: string
) => {
  return { type: SAVE_SITE_FAILED, siteId, error };
};

export const publishSitePending: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: PUBLISH_SITE_PENDING, siteId };
};

export const publishSiteFulfilled: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: PUBLISH_SITE_FULFILLED, siteId };
};

export const publishSiteFailed: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: PUBLISH_SITE_FAILED, siteId };
};

export const unPublishSitePending: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: UNPUBLISH_SITE_PENDING, siteId };
};

export const unPublishSiteFulfilled: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: UNPUBLISH_SITE_FULFILLED, siteId };
};

export const unPublishSiteFailed: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: UNPUBLISH_SITE_FAILED, siteId };
};

export const archiveSitePending: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: ARCHIVE_SITE_PENDING, siteId };
};

export const archiveSiteFulfilled: ActionCreator<AnyAction> = (
  siteId: number
) => {
  return { type: ARCHIVE_SITE_FULFILLED, siteId };
};

export const archiveSiteFailed: ActionCreator<AnyAction> = (siteId: number) => {
  return { type: ARCHIVE_SITE_FAILED, siteId };
};
export const fetchSearchResultsPending = () => ({
  type: 'FETCH_SEARCH_RESULTS_PENDING',
});
export const fetchSearchResultsFulfilled = (data: any) => ({
  type: 'FETCH_SEARCH_RESULTS_FULFILLED',
  payload: data,
});
export const fetchSearchResultsFailed = (error: string) => ({
  type: 'FETCH_SEARCH_RESULTS_FAILED',
  payload: error,
});
export const changeWidgetVisible: ActionCreator<AnyAction> = (
  siteId: number,
  pageId: number,
  parentWidgetId: string,
  widgetId: string,
  visible: boolean,
  currentTabIndex?: number | string
) => {
  return {
    type: CHANGE_WIDGET_VISIBLE,
    siteId,
    pageId,
    parentWidgetId,
    widgetId,
    visible,
    currentTabIndex,
  };
};

export const updateSite: ActionCreator<AnyAction> = (
  siteId: number,
  site: Site
) => {
  return { type: UPDATE_SITE, siteId, site };
};

export const setActiveWidgetId: ActionCreator<AnyAction> = (
  widgetId: string
) => {
  return { type: SET_ACTIVE_WIDGET_ID, widgetId };
};

export const setSiteDataForTemplateEditing: ActionCreator<AnyAction> = (
  site: Site,
  pages: Array<Page>
) => {
  return {
    type: SET_SITE_DATA_FOR_TEMPLATE_EDITING,
    site,
    pages,
  };
};

export const resetSiteDataForTemplateEditing = () => ({
  type: RESET_SITE_DATA_FOR_TEMPLATE_EDITING,
});

const fetchPagesByPending: ActionCreator<AnyAction> = () => {
  return { type: FETCH_PAGES_BY_TIME_PENDING };
};

/**
 * Side effects
 */

// TODO: Consider moving toasts out of state code

export const fetchSites: ThunkActionCreator = () => dispatch => {
  dispatch(fetchSitesPending());
  doFetchSites()
    .then(sites => {
      dispatch(fetchSitesFulfilled(sites));
    })
    .catch(_ => {
      dispatch(fetchSitesFailed());
    });
};

export const fetchSitesByUuid: ThunkActionCreator = () => dispatch => {
  dispatch(fetchSitesByUuidPending());
  doFetchSitesByUuid()
    .then(sites => {
      dispatch(fetchSitesByUuidFulfilled(sites));
    })
    .catch(_ => {
      dispatch(fetchSitesByUuidFailed());
    });
};

export const fetchSite: ThunkActionCreator = (
  siteId: number,
  openDialog: boolean
) => dispatch => {
  dispatch(fetchSitePending());
  doFetchSite(siteId)
    .then(site => {
      dispatch(fetchSiteFulfilled(site));
      if (openDialog) {
        if (site.apps.length === 0) {
          dispatch(
            openSiteListDialog(
              SiteListDialogType.DELETE,
              site.siteId,
              site.name
            )
          );
        } else {
          dispatch(
            openSiteListDialog(
              SiteListDialogType.CANNOT_DELETE,
              site.siteId,
              site.name
            )
          );
        }
      }
    })
    .catch(_ => {
      dispatch(fetchSiteFailed());
    });
};

/**
 * Create a site. Value of domain will concatenated with base domain.
 */

export const createSite: ThunkActionCreator = (
  site: Partial<Site>,
  template
) => dispatch => {
  dispatch(createSitePending());
  doCreateSite({
    ...site,
    idpHint: site.idpHint ? site.idpHint : '',
    domain: `${site.domain}.${site.domainExtension}`,
    clientId: `${site.domain}`,
    product: {
      productId: '12',
      name: 'test',
    },
  })
    .then(site => {
      doFetchPages(site.siteId).then(pages => {
        dispatch(createSiteFulfilled(site));
        //fetch newly created page to update with template
        const pageToUpdate = pages.find(
          page => page.id === site.horizonhomepageId
        );
        const updatedPage: Page = {
          ...pageToUpdate,
          current: {
            ...pageToUpdate.current,
            content: template,
          },
        };
        dispatch(closeCreateSiteDialog());
        toast('Site created', { type: 'success', theme: 'colored' });
        dispatch(updatePageContent(site.siteId, pageToUpdate.id, updatedPage));
        dispatch(savePage(site.siteId, pageToUpdate.id, updatedPage.current));
      });
    })
    .catch(e => {
      dispatch(createSiteFailed());
      if (e.response.status === 400) {
        toast('Tenancy is already associated with a different site', {
          type: 'error',
          theme: 'colored',
        });
      } else if (e.response.status >= 500) {
        toast('Unable to associate site with tenancy', {
          type: 'error',
          theme: 'colored',
        });
      } else {
        toast(e.message, { type: 'error', theme: 'colored' });
      }
    });
};

export const saveSite: AsyncThunkActionCreator<Promise<Site>> = (
  siteId: number,
  showToastMessage?: boolean
) => (dispatch: any, getState: any): Promise<Site> => {
  showToastMessage = showToastMessage ?? true;
  const site = selectSite(siteId)(getState());
  const promises: Array<Promise<Site>> = [];
  const errors: any = {
    removeStore: { isError: false, message: '' },
    addStore: { isError: false, message: '' },
    saveSite: { isError: false, message: '' },
  };

  const { siteProvisioningStores, prevSiteProvisioningStores } = site;
  const toAddSiteProvisioningStores = siteProvisioningStores.filter(
    provStoreId => !prevSiteProvisioningStores.includes(provStoreId)
  );
  const toRemoveSiteProvisioningStores = prevSiteProvisioningStores.filter(
    provStoreId => !siteProvisioningStores.includes(provStoreId)
  );
  dispatch(saveSitePending(siteId));
  if (toRemoveSiteProvisioningStores?.length) {
    promises.push(
      doRemoveSiteProvisioningStores(siteId, toRemoveSiteProvisioningStores)
        .then(updatedSite => updatedSite)
        .catch(() => {
          // catch error to allow other calls to still complete
          errors.removeStore.isError = true;
          errors.removeStore.message = 'Delete Site Provisioning Stores Failed';
          // return site without provisiong stores removed
          return {
            ...site,
            siteProvisioningStores: prevSiteProvisioningStores,
          };
        })
    );
  }
  if (toAddSiteProvisioningStores?.length) {
    promises.push(
      doSaveSiteProvisioningStores(siteId, toAddSiteProvisioningStores)
        .then((updatedSite: Site) => ({
          ...updatedSite,
          siteProvisioningStores: updatedSite.siteProvisioningStores?.filter(
            s => !toRemoveSiteProvisioningStores?.includes(s)
          ),
        }))
        .catch(e => {
          // catch error to allow other calls to still complete
          errors.addStore.isError = true;
          if (e.response.status === 409) {
            // site tenanacy association not found for link security provisioning stores (id = 2)
            errors.addStore.message = 'Site Tenancy Association Not Found';
          } else {
            errors.addStore.message = 'Save Site Provisioning Stores Failed';
          }
          // return site without new provisiong stores added
          return {
            ...site,
            siteProvisioningStores: prevSiteProvisioningStores?.filter(
              s => !toRemoveSiteProvisioningStores?.includes(s)
            ),
          };
        })
    );
  }
  promises.push(
    doSaveSite(siteId, selectSite(siteId)(getState()))
      .then(updatedSite => updatedSite)
      .catch(_ => {
        errors.saveSite.isError = true;
        errors.saveSite.message = 'Save site failed';
        return { ...site };
      })
  );
  return Promise.all(promises).then(results => {
    if (promises.length > 1) {
      // grab provisioning stores from results of provisioningStore calls
      const siteProvisioningStores = [
        ...new Set(
          results
            .slice(0, results.length - 1)
            .reduce(
              (stores, site) => [
                ...stores,
                ...(site.siteProvisioningStores ?? []),
              ],
              []
            )
        ),
      ];
      const site = {
        ...results[results.length - 1],
        siteProvisioningStores,
        prevSiteProvisioningStores: siteProvisioningStores,
      };
      if (
        errors.saveSite.isError &&
        errors.removeStore.isError &&
        errors.addStore.isError
      ) {
        dispatch(saveSiteFailed(siteId, errors.saveSite.message));
        toast(errors.saveSite.message, { type: 'error', theme: 'colored' });
      } else if (
        errors.saveSite.isError ||
        errors.removeStore.isError ||
        errors.addStore.isError
      ) {
        const error = `${errors.saveSite.message} ${errors.addStore.message} ${errors.removeStore.message}`;
        dispatch(saveSiteFulfilled(siteId, site, error));
        toast(error, {
          type: errors.saveSite.isError ? 'error' : 'warning',
          theme: 'colored',
        });
      } else {
        dispatch(saveSiteFulfilled(siteId, site, ''));
        if (showToastMessage) {
          toast('Site saved', { type: 'success', theme: 'colored' });
        }
        return results[0];
      }
    } else {
      if (!errors.saveSite.isError) {
        dispatch(saveSiteFulfilled(siteId, results[0]));
        dispatch(closeVersionHistoryDialog());
        if (showToastMessage) {
          toast('Site saved', { type: 'success', theme: 'colored' });
        }
        return results[0];
      } else {
        dispatch(saveSiteFailed(siteId, errors.saveSite.message));
        toast(errors.saveSite.message, { type: 'error', theme: 'colored' });
      }
    }
  });
};

export const publishSite: AsyncThunkActionCreator<Promise<void>> = (
  siteId: number,
  publishMessage: string
) => {
  return dispatch => {
    dispatch(publishSitePending(siteId));
    return doPublishSite(siteId, publishMessage)
      .then(() => {
        dispatch(publishSiteFulfilled(siteId));
        dispatch(closePublishNoteDialog());
        toast('Site published', { type: 'success', theme: 'colored' });
      })
      .catch(e => {
        dispatch(publishSiteFailed(siteId));
        toast(e.message, { type: 'error', theme: 'colored' });
      });
  };
};

export const publishSiteToDemo: AsyncThunkActionCreator<Promise<void>> = (
  siteId: number
) => {
  return dispatch => {
    dispatch(publishSitePending(siteId));
    return doPublishSiteToDemo(siteId)
      .then(() => {
        dispatch(publishSiteFulfilled(siteId));
        toast('Site published to Demo', { type: 'success', theme: 'colored' });
      })
      .catch(e => {
        dispatch(publishSiteFailed(siteId));
        toast(e.message, { type: 'error', theme: 'colored' });
      });
  };
};

export const unPublishSite: AsyncThunkActionCreator<Promise<void>> = (
  siteId: number
) => {
  return dispatch => {
    dispatch(unPublishSitePending(siteId));
    return doUnPublishSite(siteId)
      .then(() => {
        dispatch(unPublishSiteFulfilled(siteId));
        toast('Site Unpublished', { type: 'success', theme: 'colored' });
      })
      .catch(e => {
        dispatch(unPublishSiteFailed(siteId));
        toast(e.message, { type: 'error', theme: 'colored' });
      });
  };
};

export const archiveSite: ThunkActionCreator = (siteId: number) => dispatch => {
  dispatch(archiveSitePending(siteId));
  doArchiveSite(siteId)
    .then(() => {
      dispatch(archiveSiteFulfilled(siteId));
      toast('Site Deleted', { type: 'success', theme: 'colored' });
    })
    .catch(e => {
      dispatch(archiveSiteFailed(siteId));
      toast(e.message, { type: 'error', theme: 'colored' });
    });
};

export const fetchPages: ThunkActionCreator = (siteId: number) => dispatch => {
  dispatch(fetchPagesPending(siteId));
  return doFetchPages(siteId)
    .then(pages => {
      dispatch(fetchPagesFulfilled(siteId, pages));
    })
    .catch(e => {
      dispatch(fetchPagesFailed(siteId));
      toast(e.message, { type: 'error', theme: 'colored' });
    });
};

export const fetchPage: ThunkActionCreator = (
  siteId: number,
  pageId: number
) => dispatch => {
  return doFetchPage(siteId, pageId).then(page => {
    dispatch({ type: FETCH_PAGE_FULFILLED, siteId, pageId, page });
  });
};

// Fetches all pages that still have placeholder content (not yet loaded from
// the server).  Returns a Promise that resolves only when every in-flight
// fetch has dispatched FETCH_PAGE_FULFILLED.  Call this before saving so
// header/footer defaultWidget changes are persisted to every page.
export const fetchAllUnloadedPages: AsyncThunkActionCreator<Promise<
  Array<Page>
>> = (siteId: number) => async (dispatch, getState): Promise<Array<Page>> => {
  if (typeof siteId !== 'number' || siteId < 0) {
    console.error('fetchAllUnloadedPages: invalid siteId provided:', siteId);
    return [];
  }
  // Clear the flag first so any new defaultWidget edits made during the
  // fetch will re-arm it correctly.
  dispatch({ type: SET_PENDING_DEFAULT_WIDGET_FETCHES, value: false });
  const pages = getSitePages(getState().sites, siteId);
  if (!pages) return [];
  const failedPageIds: number[] = [];
  const promises = (Object.values(pages) as any[])
    .filter(p => {
      if (typeof p.id !== 'number' || p.id < 0) {
        console.error(
          'fetchAllUnloadedPages: skipping page with invalid id:',
          p.id
        );
        return false;
      }
      return !isContentLoaded(p.current);
    })
    .map(async p => {
      try {
        await ((dispatch(fetchPage(siteId, p.id)) as unknown) as Promise<void>);
      } catch (error) {
        failedPageIds.push(p.id);
        dispatch({ type: FETCH_PAGE_FAILED, siteId, pageId: p.id, error });
        console.error(
          'fetchAllUnloadedPages: failed to fetch page:',
          p.id,
          error
        );
      }
    });
  if (promises.length > 0) {
    await Promise.all(promises);
  }
  if (failedPageIds.length > 0) {
    // Re-arm the flag so the next save retries the failed pages.
    dispatch({ type: SET_PENDING_DEFAULT_WIDGET_FETCHES, value: true });
    throw new Error(
      `fetchAllUnloadedPages: failed to fetch pages: ${failedPageIds.join(
        ', '
      )}`
    );
  }
  // Return fresh filtered pages from updated Redux state so the caller doesn't
  // have to rely on a stale React ref (filteredPagesRef) that hasn't been
  // refreshed by a re-render yet. This ensures newly fetched pages are included
  // in handleSavePage even when the user saves immediately after a header/footer
  // edit (before React has had a chance to re-render with the new Redux state).
  const freshPages = getSitePages(getState().sites, siteId);
  return freshPages
    ? filterValidPages(Object.values(freshPages) as Page[])
    : [];
};

// Dispatches updateWidgetConfig and, when the widget is a defaultWidget
// (header/footer), background-fetches any pages not yet loaded so they
// receive the propagated change and are included in the next save.
export const updateWidgetConfigAndFetchUnloaded: ThunkActionCreator = (
  siteId: number,
  pageId: number,
  widgetId: string,
  config: any,
  defaultWidget: boolean
) => (dispatch, getState) => {
  dispatch(updateWidgetConfig(siteId, pageId, widgetId, config, defaultWidget));
  if (defaultWidget && widgetId !== 'root') {
    const pages = getSitePages(getState().sites, siteId);
    if (pages) {
      const placeholderPages = (Object.values(pages) as any[]).filter(
        p => p.id !== pageId && !isContentLoaded(p.current)
      );
      if (placeholderPages.length > 0) {
        dispatch({ type: SET_PENDING_DEFAULT_WIDGET_FETCHES, value: true });
        placeholderPages.forEach(p =>
          Promise.resolve(dispatch(fetchPage(siteId, p.id)) as unknown).catch(
            (error: unknown) => {
              dispatch({
                type: FETCH_PAGE_FAILED,
                siteId,
                pageId: p.id,
                error,
              });
              console.error(
                'fetchPage background fetch failed for page:',
                p.id,
                error
              );
            }
          )
        );
      }
    }
  }
};

export const createPage: AsyncThunkActionCreator<Promise<Page>> = (
  siteId: number,
  requestedPage: Partial<PageVersion>
) => (dispatch: any): Promise<Page> => {
  dispatch(createPagePending(siteId));
  return doCreatePage(siteId, requestedPage)
    .then(createdPage => {
      doFetchPages(siteId).then(pages => {
        dispatch(createPageFulfilled(siteId, createdPage));
        dispatch(closeCreatePageDialog());
        // The v4 POST response (like PUT) omits content and pageBackground.
        // Merge the original request values so savePage preserves them even
        // if the API did not echo them back in the creation response.
        const pageVersionToSave: PageVersion = {
          ...createdPage.current,
          content: createdPage.current?.content ?? requestedPage.content,
          pageBackground:
            createdPage.current?.pageBackground ?? requestedPage.pageBackground,
        };
        dispatch(savePage(siteId, createdPage.id, pageVersionToSave));
        dispatch(saveInitialPages(pages));
        toast('Page created', { type: 'success', theme: 'colored' });
      });
      return createdPage;
    })
    .catch(e => {
      dispatch(createPageFailed(siteId));
      toast(e.message, { type: 'error', theme: 'colored' });
      return Promise.reject(e);
    });
};

export const fetchSearchResults = (query: string, site: Site) => (
  dispatch: any
): Promise<any> => {
  dispatch(fetchSearchResultsPending());

  return doFetchSearchResults(query, site)
    .then(response => {
      if (response) {
        dispatch(fetchSearchResultsFulfilled(response));
        return response;
      } else {
        throw new Error('Invalid API response');
      }
    })
    .catch(error => {
      dispatch(fetchSearchResultsFailed(error.message));
      toast(error.message, { type: 'error', theme: 'colored' });

      return [];
    });
};

export const savePage: ThunkActionCreator = (
  siteId: number,
  pageId: number,
  page: PageVersion,
  skipSiteRefresh = false
) => (dispatch, getState) => {
  dispatch(savePagePending(siteId, pageId));
  const sitePages = getSitePages(getState().sites, siteId);
  const footerReferenceContent = sitePages
    ? getBestFooterReferenceContent(Object.values(sitePages) as Page[], pageId)
    : undefined;
  const pageToSave = footerReferenceContent
    ? normalizePageFooterContent(page, footerReferenceContent)
    : page;

  return doSavePage(siteId, pageId, pageToSave)
    .then(page => {
      dispatch(savePageFulfilled(siteId, pageId, page));
      //disabling until entire pages save endpoint is ready
      // toast('Page saved', { type: 'success', theme: 'colored' });
      if (!skipSiteRefresh) {
        doFetchSite(siteId).then(site => {
          dispatch(saveInitialSite(site));
        });
      }
    })
    .catch(e => {
      dispatch(savePageFailed(siteId, pageId));
      toast(e.message, { type: 'error', theme: 'colored' });
    });
};

export const fetchPagesByTimeFulfilled: ActionCreator<AnyAction> = (
  pages: Array<Page>,
  siteId: number
) => {
  return { type: FETCH_PAGES_BY_TIME_FULFILLED, pages, siteId };
};

export const fetchPagesByTimeFailed: ActionCreator<AnyAction> = () => {
  return { type: FETCH_PAGES_BY_TIME_FAILED };
};

export const fetchPagesByTime: ThunkActionCreator = (
  siteId: number,
  deployedTime: number
) => dispatch => {
  dispatch(fetchPagesByPending());
  doFetchPagesByTime(siteId, deployedTime)
    .then(pages => {
      dispatch(fetchPagesByTimeFulfilled(pages, siteId));
    })
    .catch(_ => {
      dispatch(fetchPagesByTimeFailed());
    });
};

export const saveAllPage: AsyncThunkActionCreator<Promise<
  Array<PageVersion>
>> = (siteId: number, pages: Array<PageVersion>) => dispatch => {
  dispatch(saveAllPagePending(siteId));
  const footerReferenceContent = getBestFooterReferenceContent(
    pages as Array<PageVersion>
  );
  const pagesToSave = footerReferenceContent
    ? pages.map(page =>
        normalizePageFooterContent(page, footerReferenceContent)
      )
    : pages;

  return doSaveAllPage(siteId, pagesToSave)
    .then(pages => {
      dispatch(saveAllPageFulfilled(siteId, pages));

      toast('All Pages saved', { type: 'success', theme: 'colored' });
      return pages;
    })
    .catch(e => {
      dispatch(saveAllPageFailed(siteId));
      toast(e.message, { type: 'error', theme: 'colored' });
      return Promise.reject(e);
    });
};

export const normalizeHeaderFooter: ActionCreator<AnyAction> = (
  siteId: number,
  currentPageId: number
) => {
  return { type: NORMALIZE_HEADER_FOOTER, siteId, currentPageId };
};

export const updateCurrentPage: ActionCreator<AnyAction> = (
  siteId: number,
  currentPage: PageVersion
) => {
  return { type: UPDATE_CURRENT_PAGE, siteId, currentPage };
};

type WidgetThemeTokens = {
  font: string;
  textPrimary: string;
  pageBg: string;
  surfaceBg: string;
  link: string;
  linkHover: string;
  hoverBg: string;
  buttonBg: string;
  buttonHoverBg: string;
  buttonText: string;
  buttonTextHover: string;
};

const SURFACE_WIDGET_TYPES = new Set([
  widgetTypes.Text,
  widgetTypes.Navigation,
  widgetTypes.AccordionWidget,
  widgetTypes.Tabs,
  widgetTypes.TextInput,
  widgetTypes.RadioButton,
  widgetTypes.Checkbox,
  widgetTypes.Dropdown,
  widgetTypes.FileUploader,
  widgetTypes.Image,
  widgetTypes.VideoUpload,
  widgetTypes.Divider,
  widgetTypes.Html,
  widgetTypes.Section,
  widgetTypes.Calendar,
  widgetTypes.Application,
  widgetTypes.Slideshow,
  widgetTypes.Banner,
  widgetTypes.Form,
  widgetTypes.RichText,
  widgetTypes.UploadWidget,
  widgetTypes.CalendarWidget,
  widgetTypes.TemplateHeaderFooterPlaceholder,
  widgetTypes.NotificationWidget,
  widgetTypes.Card,
]);

/**
 * Applies the common font, text, and background theme values to a widget.
 *
 * @param widget - Widget whose config should receive theme values.
 * @param tokens - Theme values resolved for the current site.
 * @returns A themed widget, or the original widget when its type is unsupported.
 */
const applyThemeToWidget = (
  widget: Widget<any>,
  tokens: WidgetThemeTokens
): Widget<any> => {
  const config = widget.config || {};

  if (SURFACE_WIDGET_TYPES.has(widget.type)) {
    return {
      ...widget,
      config: {
        ...config,
        font: tokens.font,
        textColor: tokens.textPrimary,
        backgroundData: { style: 'Color', color: tokens.surfaceBg },
      },
    };
  }

  switch (widget.type) {
    case widgetTypes.Search:
      return {
        ...widget,
        config: {
          ...config,
          font: tokens.font,
          textColor: tokens.textPrimary,
          backgroundData: { style: 'Color', color: tokens.pageBg },
        },
      };
    case widgetTypes.Button:
      return {
        ...widget,
        config: {
          ...config,
          font: tokens.font,
          textColor: tokens.buttonText,
          backgroundData: { style: 'Color', color: tokens.buttonBg },
          hoverData: {
            ...config.hoverData,
            font: tokens.font,
            backgroundData: { style: 'None', color: tokens.buttonHoverBg },
            textColor: tokens.buttonTextHover,
          },
        },
      };
    case widgetTypes.LoginButton:
      return {
        ...widget,
        config: {
          ...config,
          font: tokens.font,
          // Ensure runtime LoginButton reflects theme colors
          textColor: tokens.textPrimary,
          signInLinkColor: tokens.textPrimary,
          buttonColor: tokens.buttonBg,
          dropdownItemsBackgroundColor: tokens.surfaceBg,
          backgroundData: { style: 'Color', color: tokens.pageBg },
          hoverData: {
            ...config.hoverData,
            font: tokens.font,
            backgroundData: { style: 'None', color: tokens.hoverBg },
          },
        },
      };
    case widgetTypes.Link:
      return {
        ...widget,
        config: {
          ...config,
          textColor: tokens.link,
          iconColor: tokens.link,
          font: tokens.font,
          backgroundData: { style: 'Color', color: tokens.pageBg },
          hoverData: {
            ...config.hoverData,
            textColor: tokens.linkHover,
            font: tokens.font,
            fontFamily: tokens.font,
            underline: true,
          },
        },
      };
    default:
      return widget;
  }
};

/**
 * Builds a themed copy of a loaded page.
 *
 * @param page - Loaded page to update.
 * @param tokens - Theme values resolved for the current site.
 * @returns A new page version with theme values applied.
 */
const applyThemeToPage = (
  page: Page,
  tokens: WidgetThemeTokens
): PageVersion => {
  const content = Object.keys(page.current.content).reduce(
    (themedContent, widgetId) => {
      const widget = page.current.content[widgetId];
      themedContent[widgetId] =
        widget &&
        typeof widget === 'object' &&
        widget.config &&
        typeof widget.config === 'object'
          ? applyThemeToWidget(widget, tokens)
          : widget;
      return themedContent;
    },
    { ...page.current.content }
  );

  return {
    ...page.current,
    pageBackground: { style: 'Color', color: tokens.pageBg, gradient: '' },
    content,
  } as PageVersion;
};

/**
 * Applies a theme across pages by generating widget tokens and dispatching updateCurrentPage.
 * Optionally persists enabledTheme on the site object.
 */
export const applyThemeToPages: any = (
  siteId: number,
  themeKey: string,
  options?: { scope?: 'all' | 'current'; persistEnabledKey?: boolean }
) => (dispatch: any, getState: any) => {
  const state = getState();
  const site = selectSite(siteId)(state);
  const pages = selectPages(siteId)(state);
  if (!site || !pages?.length) return;

  // Lazy import to avoid circular deps in reducer
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { getTokensForWidgets } = require('shared/util/themeTokens');
  const tokens = getTokensForWidgets(themeKey, site);

  const targetPages =
    options?.scope === 'current'
      ? pages.filter(p => p.current?.pageId === site.horizonhomepageId)
      : pages;

  targetPages.forEach(page => {
    // Skip unvisited pages — their content is templates[0].widgets (sentinel).
    // Spreading the sentinel creates a new object reference that breaks the
    // filterValidPages sentinel check, causing these pages to be included in
    // the next save and wiping their real server content.
    if (!isContentLoaded(page.current)) {
      return;
    }

    dispatch(updateCurrentPage(siteId, applyThemeToPage(page, tokens)));
  });

  if (options?.persistEnabledKey) {
    dispatch(
      updateSite(siteId, {
        ...site,
        theme: { ...site.theme, enabledTheme: themeKey },
      } as any)
    );
  }
};

export const updatePageDefaultWidget: ThunkActionCreator = (
  siteId: number,
  pageId: number,
  widgetId: string,
  config: any,
  xDifference: number,
  yDifference: number
) => (dispatch, getState) => {
  dispatch({
    type: UPDATE_PAGE_DEFAULT_WIDGET,
    siteId,
    widgetId,
    config,
    xDifference,
    yDifference,
    pageId,
  });
  // Background-fetch pages not yet loaded so they receive the propagated
  // defaultWidget (header/footer) change and get included in the next save.
  const pages = getSitePages(getState().sites, siteId);
  if (pages) {
    const placeholderPages = (Object.values(pages) as any[]).filter(
      p => p.id !== pageId && !isContentLoaded(p.current)
    );
    if (placeholderPages.length > 0) {
      dispatch({ type: SET_PENDING_DEFAULT_WIDGET_FETCHES, value: true });
      placeholderPages.forEach(p =>
        Promise.resolve(dispatch(fetchPage(siteId, p.id)) as unknown).catch(
          (error: unknown) => {
            dispatch({ type: FETCH_PAGE_FAILED, siteId, pageId: p.id, error });
            console.error(
              'fetchPage background fetch failed for page:',
              p.id,
              error
            );
          }
        )
      );
    }
  }
};
/**
 * Remove page from a site. Also cleans up any links to that page from the
 * site's nav structure.
 */
export const removePage: ThunkActionCreator = (
  siteId: number,
  pageId: number
) => (dispatch, getState) => {
  dispatch(removePagePending(siteId, pageId));
  dispatch(saveSitePending(siteId));
  const site = selectSite(siteId)(getState());
  doSaveSite(siteId, {
    ...site,
    header: {
      ...site.header,
      nav: {
        ...site.header.nav,
        items: removePageFromNav(pageId, site.header.nav.items),
      },
    },
  })
    .then(site => {
      dispatch(saveSiteFulfilled(siteId, site));
      doRemovePage(siteId, pageId)
        .then(() => {
          doFetchPages(siteId).then(pages => {
            dispatch(removePageFulfilled(siteId, pageId));
            toast('Page deleted', { type: 'success', theme: 'colored' });
            dispatch(saveSitePages(site, pages));
          });
        })
        .catch(e => {
          dispatch(removePageFailed(siteId, pageId));
          toast(e.message, { type: 'error', theme: 'colored' });
        });
    })
    .catch(e => {
      dispatch(saveSiteFailed(siteId));
      dispatch(removePageFailed(siteId, pageId));
      toast(e.message, { type: 'error', theme: 'colored' });
    });
};

/**
 * Selectors
 */

const selectSlice: Selector<State> = () => state => {
  return state.sites;
};

export const selectSitesMeta: Selector<StateMeta> = () => state => {
  return selectSlice()(state).meta;
};

/**
 * Internal-only selector that returns complete @type {SiteSlice} objects
 */
const selectSitesInternal: Selector<Array<SiteSlice>> = () => state => {
  return selectSlice()(state).data;
};

const selectBaseSite: Selector<SiteSlice> = () => state => {
  return selectSlice()(state).data[0];
};

export const selectDomain: Selector<string> = () => state => {
  return selectBaseSite()(state).domain;
};
/**
 * Selector to retrieve a @type {Site}
 */
export const selectSites: Selector<Array<Site>> = () => state => {
  const rawSites = selectSitesInternal()(state);
  return rawSites.map(({ pages: _a, meta: _b, ...site }) => site);
};

/**
 * Internal-only selector that returns the complete @type {SiteSlice} object
 */
export const selectSiteInternal: Selector1<SiteSlice, number> = (
  siteId: number
) => state => {
  return selectSitesInternal()(state).find(site => siteId === site.siteId);
};

/**
 * Selector to retrieve a @type {Site}
 */
export const selectSite: Selector1<Site, number> = (
  siteId: number
) => state => {
  const siteSlice = selectSiteInternal(siteId)(state);
  // Strip off SiteSlice-specific properties
  const { pages, meta, ...site } = siteSlice;

  // Ensure theme is an object contains the property font or not if yes set the value to Roboto or do nothing if there is no property found.
  if (typeof site.theme.font === 'string') {
    const myFont: NewFont = {
      size: {
        body: {
          base: {
            value: 11,
          },
        },
      },
      weight: {
        base: {
          value: 'normal',
        },
      },
      family: {
        base: {
          value: 'OptumSans',
        },
      },
    };

    site.theme.font = myFont;
  }

  return site;
};

export const selectCreateSitePending: Selector<StateMeta> = () => state => {
  return selectSlice()(state).createSiteMeta;
};

export const selectNewSite: Selector<number> = () => state => {
  return selectSlice()(state).newSiteId;
};

export const selectSiteMeta: Selector1<StateMeta, number> = (
  siteId: number
) => state => {
  return (
    selectSiteInternal(siteId)(state) && selectSiteInternal(siteId)(state).meta
  );
};

export const selectSitePublishingMeta: Selector<StateMeta> = () => state => {
  return selectSlice()(state).publishMeta;
};

const selectPagesInternal: Selector1<SiteSlice['pages'], number> = (
  siteId: number
) => state => {
  return (
    selectSiteInternal(siteId)(state) && selectSiteInternal(siteId)(state).pages
  );
};

export const selectPages: Selector1<Array<Page>, number> = (
  siteId: number
) => state => {
  const site = selectSiteInternal(siteId)(state);
  return Object.keys(site.pages).map(key => site.pages[key] as Page);
};

export const selectPage: Selector2<Page, number, number> = (
  siteId: number,
  pageId: number
) => state => {
  return (
    selectPagesInternal(siteId)(state) &&
    selectPagesInternal(siteId)(state)[pageId]
  );
};

export const selectDefaultPage: Selector1<Page, number> = (
  siteId: number
) => state => {
  const site = selectSiteInternal(siteId)(state);
  const pageId = Object.keys(site.pages).find(
    key => site.pages[key].current?.slug === 'defaultContentPage'
  );
  return site.pages[pageId];
};

export const selectCurrentPage: Selector2<PageVersion, number, number> = (
  siteId: number,
  pageId: number
) => state => {
  return selectPage(siteId, pageId)(state)?.current;
};

export const selectWidget: Selector3<Widget<any>, number, number, string> = (
  siteId: number,
  pageId: number,
  widgetId: string
) => state => {
  return selectCurrentPage(siteId, pageId)(state)?.content?.[widgetId];
};

export const disableAccountNameSelection: Selector1<boolean, number> = (
  siteId: number
) => state => {
  const site = selectSite(siteId)(state);
  return site.orgAccount !== null;
};

export const selectPageWithWidgetPresent: Selector2<string, number, string> = (
  siteId: number,
  widget: string
) => state => {
  let slug = '';
  const sitePages = selectPages(siteId)(state);
  for (const sitePage of sitePages) {
    const childIds = Object.keys(sitePage.current.content).filter(
      id => id !== 'root'
    );
    for (const childId of childIds) {
      if (sitePage.current.content[childId].type === widget) {
        slug = sitePage.current.slug;
        break;
      }
    }
  }
  return slug;
};
